/* eslint-disable */
import React, { Component } from 'react';
import $ from 'jquery';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { SketchPicker } from 'react-color'
import reactCSS from 'reactcss'
import { apiUrl, cmscontentURL,mediaUrl} from'../Config/Config';

import Select from 'react-select';
import axios from 'axios';
import { scrollToTopValidate, PageTitle,scrollToTop } from "../Helpers/SettingHelper";
import Addinputsimple from './Addinputsimple';
import { ShadowPicker } from "react-shadow-picker";
import { lang } from '../Helpers/lang';

import queryString from "query-string";
class Setting extends Component {
	
	constructor(props)
	{
		super(props);	
		this.state = {
			settings_id:'',
			settings_site_title:'',
			settings_from_name:'',
			settings_admin_email:'',
			settings_from_email:'',
			settings_mailpath:'',
			settings_company_address:'',
			settings_commission_percentage:'',
			settings_smtp_host:'',
			settings_smtp_user:'',
			settings_smtp_pass:'',
			settings_smtp_port:'',
			settings_username:'',
			settings_mobileno:'',
			settings_email_footer:'',
			settings_commision_amount:'',
			smtp_checked:false,
			
			Loading: false,
			drLoading: false,
			displayColorPicker: false,
			color: {
			r: '241',
			g: '112',
			b: '19',
			a: '1',
			},
			hexColor:'#f17013',
			settings_public_key:'',
			settings_product_key:'',
			settings_secret_key:'',
			stripe_live_checked:false,
			stripe_sandbox_checked:false,
			settings_embedcode:'',
			setting_goal_amount:'',
			settings_access_code:'',
			st_position_left:'',
			st_position_right:'',
			st_position_top:'',
			st_position_bottom:'',
			st_plugin_height:'',
			st_plugin_left_space:'',
			st_plugin_right_space:'',
			st_plugin_top_space:'',
			st_plugin_bottom_space:'',
			st_plugin_ai_width:50,
			st_loader_text:'',
			st_loader_image:'',
			welcome_invite_friends:'',
			st_invite_image:'',
			st_email_logo:'',
			domainSets:'',
			removeID:[
        	],
			fonttype : [],
			selectedFont:'',
			fontvalue:'',
			st_position_checked:true,
			st_position:'',
			supporter_additional_fee:'',
			product_layout2_checked:true,
			product_layout3_checked:false,
			google_analystic_code:'',
			category_icons_yes:true,
			category_icons_no:false,
			header_cat_limit:1,
			domain_count:'',
			faqmodelguest: '',
			faqmodeluser: '',
			faqmodelcompany:'',
			faqmodelrehab:'',
			selectedfaqmodeluserval:'',
			selectedallmodelvalue : '',
			selectedfaqmodelguestval:'',
			selectedfaqmodelcompanyval:'',
			selectedfaqmodelrehabval:'',
			selectedfaqmodelguest:'',
			selectedfaqmodelcompany:'',
			selectedfaqmodelrehab:'',
			selectedfaqmodeluserval:'',
			ai_fine_tune_model_id:'',
			aichat_type:"text",
			aichat_code:"",
			description : '',
			dashboard_view:"",
			plugin_size:"",
			shadow:"0 18px 21px 0 #0000005c",
			display_tab:"",
			st_product_image:"",
			st_product_line:"",
			st_line_color:"",
			primary_font:'',
			main_tab_font_size:'',
			menu_font_size:'',
			selectedFontVariant:'',
			st_varient_id: [],
			st_inventory_count: 0,
			fontDetails: [
				
			],		
			
			pluginSizeDetails: [
				{value : 'small' , label : "600 px"},
				{value : 'extended' , label : "700 px"},
				{value : 'large' , label : "800 px"},
				{value : 'exlarge' , label : "900 px"},
				{value : 'large1000' , label : "1000 px"},
			],
			selPluginSize : '',
			selPluginSizeVal : '',

			chat_ai_key: '',
			tracking_limit: '',
			plugin_close_content: '',
			upgrade_content: '',
			google_conversation_code: '',
			invite_friends: '',
			st_earning_claims_content: '',
			st_invite_claim_eligible: '',
			st_product_image_size: '',
			st_invite_earning_amount: '',
			line_height:'',

			productSortDetails: [
				{value : 'asc' , label : "Price Asc"},
				{value : 'desc' , label : "Price Desc"},
				{value : 'relevance' , label : "Relevancy"},				
			],
			product_sort_by:"",
			selProductSort : '',
			selProductSortVal : '',
			pluginOuterSpaceChecked:false,
			pluginRadius:0,
			dropdownRadius:0,
			inputRadius:0,
			textareaRadius:0,
			loader_image_preview:'',
			loader_image_name:'',
			loader_image:'',
			invite_image_preview:'',
			invite_image_name:'',
			invite_image:'',
			mail_image_preview:'',
			mail_image_name:'',
			mail_image:'',
			shortcutBoxShadowSt:false,
			shortcutBoxShadowDet:'',
			shadow: "",
			shadows: {
				pluginShadow: "0px 24px 34px #0404052e",
				dashboardShadowGrid: "0 10px 21px 0 #0000001c",
				dashboardShadowList: "0 21px 21px 0 #0000001c",
				//sideMenu: "-2px 10px 15px #3434375e",
				largeButton: "0 4px 18px 0 #0404052e",
				textarea: "0 7px 10px -7px #04040422",
				//shortcutMenu: "0px 3px 21px 0px #9f99995c",
				shadowPluginOpenButton: "0px 2px 36px #0404052e",
				shadowDropdownMenu: "0px 12px 30px #0404052e",
				shadowSearchDropdown: "0px 40px 50px -40px #3434375E",
				shadowAISidebar: '1px 0px #0000000c',
				shadowListRow: '0px 15px 10px -15px #0404052e',
				shadowTableRow: '0px 7px 8px -7px #0404052e',
				// shadowPluginInset: "inset 5px 0px 15px 0 #3434372b",
				shadowPluginInsetLeft: "inset 15px 0 10px -10px #2727272b",
				shadowPluginInsetRight: "",
				shadowPluginInsetTop: "",
				shadowPluginInsetBottom: "",

				shadowInput: "5px 0px 5px 0px #3434372b",
				shadowText: "0 7px 10px -7px #04040422",
				shadowLeftSidebar: "0px 3px 21px 0px #9f99995c",
				shadowRightSidebar: "0px 3px 21px 0px #9f99995c",
				shadowMainAITextarea: "inset 5px 0px 5px 0px #3434372b",
				shadowPluginOpenButtonInset: "inset 5px 0px 5px 0px #3434372b",
			},
			activeShadowType: "largeButton",

			st_aisidebar_width:"",
			st_aisidebar_collapsed_width:"",
			st_aisidebar_icon_width:"",
			themeData : [],
			selTheme  : [],
			theme_id  : '',
		};
		var qs = require('qs');
		var admin_id = localStorage.getItem('admin_id');
		var postobject = {
			admin_id:  admin_id,
			
		};

		
		axios.post(apiUrl+"adminpanel/adminsettings",qs.stringify(postobject)).then(res => {
			if(res.data.results){
				const formpayload = res.data.results;
				 const newShadows = {
					pluginShadow: formpayload.plugin_shadow,
					dashboardShadowGrid: formpayload.dashboard_shadow_grid,
					dashboardShadowList: formpayload.dashboard_shadow_list,
					// sideMenu: formpayload.sidemenu_shadow,
					// shortcutMenu: formpayload.shortcut_shadow,
					largeButton: formpayload.button_shadow,
					textarea: formpayload.textarea_shadow,
					shadowPluginOpenButton: formpayload.shadowPluginOpenButton,
					shadowDropdownMenu: formpayload.shadowDropdownMenu,
					shadowSearchDropdown: formpayload.shadowSearchDropdown,
					shadowAISidebar: formpayload.shadowAISidebar,
					shadowListRow: formpayload.shadowListRow,
					shadowTableRow: formpayload.shadowTableRow,
					//shadowPluginInset: formpayload.shadowPluginInset,
					shadowPluginInsetLeft: formpayload.shadowPluginInsetLeft,
					shadowPluginInsetRight: formpayload.shadowPluginInsetRight,
					shadowPluginInsetTop: formpayload.shadowPluginInsetTop,
					shadowPluginInsetBottom: formpayload.shadowPluginInsetBottom,
					shadowInput: formpayload.shadowInput,
					shadowText: formpayload.shadowText,
					shadowLeftSidebar: formpayload.shadowLeftSidebar,
					shadowRightSidebar: formpayload.shadowRightSidebar,
					shadowMainAITextarea: formpayload.shadowMainAITextarea,
					shadowPluginOpenButtonInset: formpayload.shadowPluginOpenButtonInset,
				};
				this.setState({ shadows: newShadows });

				this.setState({settings_id:formpayload.settings_id});
				this.setState({settings_site_title:formpayload.settings_site_title});
				this.setState({settings_from_name:formpayload.settings_from_name});
				this.setState({settings_admin_email:formpayload.settings_admin_email});
				this.setState({settings_from_email:formpayload.settings_from_email});
				this.setState({settings_mailpath:formpayload.settings_mailpath});				
				this.setState({settings_smtp_host:formpayload.settings_smtp_host});
				this.setState({settings_smtp_user:formpayload.settings_smtp_user});
				this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
				this.setState({settings_smtp_port:formpayload.settings_smtp_port});
				this.setState({settings_username:formpayload.settings_username});
				this.setState({settings_mobileno:formpayload.settings_mobileno});
				this.setState({settings_email_footer:formpayload.settings_email_footer});
				this.setState({hexColor:formpayload.settings_site_background_color});
				this.setState({settings_public_key:formpayload.settings_public_key});
				this.setState({settings_product_key:formpayload.settings_product_key});
				this.setState({setting_goal_amount:formpayload.setting_goal_amount});
				this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
				this.setState({settings_secret_key:formpayload.settings_secret_key});
				this.setState({settings_embedcode:formpayload.settings_embedcode});
				this.setState({settings_access_code:formpayload.access_code});				
				this.setState({st_position_left:formpayload.st_position_left});
				this.setState({st_position_right:formpayload.st_position_right});
				this.setState({st_position_top:formpayload.st_position_top});
				this.setState({st_position_bottom:formpayload.st_position_bottom});
				this.setState({st_plugin_height:formpayload.st_plugin_height});
				this.setState({st_plugin_left_space:formpayload.st_plugin_left_space});
				this.setState({st_plugin_right_space:formpayload.st_plugin_right_space});
				this.setState({st_plugin_top_space:formpayload.st_plugin_top_space});
				this.setState({st_plugin_bottom_space:formpayload.st_plugin_bottom_space});
				this.setState({st_plugin_ai_width:formpayload.st_plugin_ai_width});
				this.setState({st_loader_text:formpayload.st_loader_text});
				this.setState({st_loader_image:formpayload.st_loader_image});
				this.setState({welcome_invite_friends:formpayload.welcome_invite_friends});
				this.setState({st_invite_image:formpayload.st_invite_image});
				this.setState({st_email_logo:formpayload.st_email_logo});
				this.setState({st_inventory_count:formpayload.st_inventory_count});
				this.setState({domainSets : formpayload.domainSets});
				this.setState({settings_commision_amount: formpayload.settings_commision_amount});								
				this.setState({header_cat_limit: formpayload.header_cat_limit});
				this.setState({np_theme: formpayload.notification_popup_theme});
				this.setState({invite_friends_perc: formpayload.invite_friends_perc});
				this.setState({domain_count: formpayload.domain_count});
				this.setState({dashboard_view: formpayload.dashboardview});
				//this.setState({plugin_size: formpayload.plugin_size});
				this.setState({display_tab: formpayload.display_tab});
				this.setState({st_product_image: formpayload.st_product_image});
				this.setState({st_product_line: formpayload.st_product_line});
				this.setState({st_line_color: formpayload.st_line_color});
				this.setState({primary_font:formpayload.primary_font});
				this.setState({main_tab_font_size:formpayload.main_tab_font_size});
				this.setState({menu_font_size:formpayload.menu_font_size});
				this.setState({line_height:formpayload.lineHeight});

				this.setState({chat_ai_key:formpayload.chat_ai_key});
				this.setState({tracking_limit:formpayload.tracking_limit});
				this.setState({plugin_close_content:formpayload.plugin_close_content});
				this.setState({upgrade_content:formpayload.upgrade_content});
				this.setState({google_conversation_code:formpayload.google_conversation_code});
				this.setState({invite_friends:formpayload.invite_friends});
				this.setState({st_earning_claims_content:formpayload.st_earning_claims_content});
				this.setState({st_invite_claim_eligible:formpayload.st_invite_claim_eligible});
				this.setState({st_invite_earning_amount:formpayload.st_invite_earning_amount});
				this.setState({st_product_image_size:formpayload.st_product_image_size});
				this.setState({shortcutBoxShadowDet:formpayload.shortcutBoxShadowDet});
				this.setState({pluginRadius:formpayload.pluginRadius});
				this.setState({dropdownRadius:formpayload.dropdownRadius});
				this.setState({inputRadius:formpayload.inputRadius});
				this.setState({textareaRadius:formpayload.textareaRadius});
				this.setState({st_aisidebar_width: formpayload.st_aisidebar_width});
				this.setState({st_aisidebar_icon_width: formpayload.st_aisidebar_icon_width});
				this.setState({st_aisidebar_collapsed_width: formpayload.st_aisidebar_collapsed_width});

				if(formpayload.plugin_size == 'small'){
					var pluginSizeLabel = 600;
				} 
				else if(formpayload.plugin_size == 'extended'){
					var pluginSizeLabel = 700;
				} 
				else if(formpayload.plugin_size == 'large'){
					var pluginSizeLabel = 800;
				} 
				else if(formpayload.plugin_size == 'exlarge'){
					var pluginSizeLabel = 900;
				} 
				else if(formpayload.plugin_size == 'large1000'){
					var pluginSizeLabel = 1000;
				} 
				this.setState({
					plugin_size: formpayload.plugin_size,
					selPluginSize: [{ value: formpayload.plugin_size, label: pluginSizeLabel+' px' }]
				});
				if(formpayload.product_sort_by == 'asc'){
					var productSortLabel = 'Price Asc';
				} 
				else if(formpayload.product_sort_by == 'desc'){
					var productSortLabel = 'Price Desc';
				} 
				else if(formpayload.product_sort_by == 'relevance'){
					var productSortLabel = 'Relevancy';
				} 			
				this.setState({
					product_sort_by: formpayload.product_sort_by,
					selProductSort: [{ value: formpayload.product_sort_by, label: productSortLabel }]
				});

				if(formpayload.settings_faq_user_model_id!== 'null' && formpayload.settings_faq_user_model_id !== ''){
					this.setState({selectedfaqmodeluser: {value:formpayload.settings_faq_user_model_id, label:formpayload.settings_faq_user_model_id},selectedfaqmodeluserval:formpayload.settings_faq_user_model_id });
				}				
				if(formpayload.settings_faq_guest_model_id!== 'null' && formpayload.settings_faq_guest_model_id !== ''){					
					this.setState({selectedfaqmodelguest: {value:formpayload.settings_faq_guest_model_id, label:formpayload.settings_faq_guest_model_id},selectedfaqmodelguestval:formpayload.settings_faq_guest_model_id});
				}
				if(formpayload.settings_task_model!== 'null' && formpayload.settings_task_model !== ''){
					
					this.setState({selectedallmodel: {value:formpayload.settings_task_model, label:formpayload.settings_task_model},selectedallmodelvalue:formpayload.settings_task_model});
				}
				if(formpayload.settings_faq_company_model_id!== 'null' && formpayload.settings_faq_company_model_id !== ''){
					this.setState({selectedfaqmodelcompany: {value:formpayload.settings_faq_company_model_id, label:formpayload.settings_faq_company_model_id},selectedfaqmodelcompanyval:formpayload.settings_faq_company_model_id });
				}
				if(formpayload.settings_faq_rehab_model_id!== 'null' && formpayload.settings_faq_rehab_model_id !== ''){
					this.setState({selectedfaqmodelrehab: {value:formpayload.settings_faq_rehab_model_id, label:formpayload.settings_faq_rehab_model_id},selectedfaqmodelrehabval:formpayload.settings_faq_rehab_model_id });
				}
				this.setState({aichat_type: formpayload.ai_model_type});
				this.setState({aichat_code: formpayload.aichat_code});
				this.setState({ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id});

				if( formpayload.google_analystic_code !== 'null'){
					this.setState({google_analystic_code: formpayload.google_analystic_code});
				}else{
					this.setState({google_analystic_code: ''});
				}
				
				if(formpayload.settings_mail_from_smtp === '1'){
					this.setState({smtp_checked: true});
				}else{
					this.setState({smtp_checked: false});
				}
				if(formpayload.pluginOuterSpaceChecked === 'true'){
					this.setState({pluginOuterSpaceChecked: true});
				}else{
					this.setState({pluginOuterSpaceChecked: false});
				}

				if(formpayload.enable_live === '1'){
					this.setState({stripe_live_checked: true,stripe_sandbox_checked:false });
				}else{
					this.setState({stripe_sandbox_checked: true,stripe_live_checked:false});
				}

				// if(formpayload.st_plugin_position === 'fixed'){
				// 	this.setState({st_position_checked: true });
				// }else{
				// 	this.setState({st_position_checked: false});
				// }
				this.setState({st_position: formpayload.st_plugin_position },()=>{
					if(formpayload.st_plugin_position =='absolute'){
						$('.d-height').removeClass('d-none');
					}else{
						$('.d-height').addClass('d-none');
					}
				});

				if(formpayload.product_layout === '2'){
					this.setState({product_layout2_checked: true });
					this.setState({product_layout3_checked: false});
				}else{
					this.setState({product_layout3_checked: true});
					this.setState({product_layout2_checked: false });
				}

				if(formpayload.show_category_icons === 'yes'){
					this.setState({category_icons_yes: true });
					this.setState({category_icons_no: false});
				}else{
					this.setState({category_icons_no: true});
					this.setState({category_icons_yes: false });
				}

				if(res.data.font!== '' && res.data.font!== null){
					this.setselectedvalue(res.data.font);
				}
				if(res.data.themelist!== '' && res.data.themelist!== null){
					this.setselectedtheme(res.data.themelist);
				}
				if(res.data.fontvarientlist!== '' && res.data.fontvarientlist!== null){
					this.setselectedvariants(res.data.fontvarientlist);
				}
				if(res.data.setting_font_varients.length>0)
				{
					this.setState({fontDetails:res.data.setting_font_varients});
				}else{
					this.setState({
						fontDetails: [
							{
							index: Math.random(),
							FontType: "",
							FontSize:'',
							FontWeight:'',
							letterSpacing:'',
							lineHeight:'',
							TopSpace:'',
							BottomSpace:'', 
							radius:'', 
							varient_id : "",
							}
						]
					});
				}
			}
		});

		
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id).then(res => {
			if(res.data.status == 'success'){
				this.setState({
					fonttype: res.data.fontlist
				})
			}else{
				//console.log("test")
			}
		});
		axios.get(apiUrl+'thememanagement/gettheme_name?admin_id='+admin_id).then(res => {
			if(res.data.status == 'success'){
				this.setState({
					themeData: res.data.themelist
				})
			}else{
				//console.log("test")
			}
		});
		this.myCallback();
		this.handleInputChange  = this.handleInputChange.bind(this);
		this.onEditorChange = this.onEditorChange.bind( this );
		this.handleEditorChange = this.handleEditorChange.bind( this );
		this.handleInputShadowChange  = this.handleInputShadowChange.bind(this);
		
    }
	onEditorChange( evt ) {
    	//console.log(evt.editor.getData())
    	var callfunc = this;
    	setTimeout(function () {
			callfunc.setState( {
				consent_form_agree: evt.editor.getData()
			});
		},1000);     
    }

	handleEditorChange = (event) => {
		this.setState({ description: event.editor.getData() });
	};

	boxShadowFunc = () =>{
		//$('.input-popup-action').addClass('show');		
		this.setState({shortcutBoxShadowSt: !this.state.shortcutBoxShadowSt})
	}
	saveboxShadowFunc = () =>{	
		this.setState({shortcutBoxShadowSt: !this.state.shortcutBoxShadowSt, shortcutBoxShadowDet: this.state.shadow})
	}
	handleInputShadowChange(event) {
		const {name, value} = event.target;      
		this.setState({
			[name]: value
		});
		if(name === 'shortcutBoxShadowDet'){
			this.setState({shadow: value});
		}
	}
   
    handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
      if(name === 'settings_mail_from_smtp'){
      	 this.setState({smtp_checked: !this.state.smtp_checked});
      }	
      if(name === 'plugin_outer_space'){
      	 this.setState({pluginOuterSpaceChecked: !this.state.pluginOuterSpaceChecked});
      }	
      if(name === 'settings_enable_live'){
      	 this.setState({stripe_live_checked: !this.state.stripe_live_checked});
      	  this.setState({stripe_sandbox_checked: !this.state.stripe_sandbox_checked});
      }	
      if(name === 'settings_enable_sandbox'){
      	 this.setState({stripe_sandbox_checked: !this.state.stripe_sandbox_checked});
      	 this.setState({stripe_live_checked: !this.state.stripe_live_checked});
      }	
      if(name === 'product_layout'){
      	 this.setState({product_layout2_checked: !this.state.product_layout2_checked});
      	 this.setState({product_layout3_checked: !this.state.product_layout3_checked});
      }

	  if(name === 'category_icons'){
		this.setState({category_icons_yes: !this.state.category_icons_yes});
		this.setState({category_icons_no: !this.state.category_icons_no});
     }

	  if(name === 'drchrono_client_id'){
		this.setState({yourclientid: value});
		this.setState({ dr_refresh_token: '' });

     }
	//  if(name === 'cancellation_fees_type_percentage'){
	// 	this.setState({cancellation_fees_type_percentage: !this.state.cancellation_fees_type_percentage});
	// 	this.setState({cancellation_fees_type_flat: !this.state.cancellation_fees_type_flat});
	// }

	// if(name === 'reschedule_fees_type_flat'){
	// 	this.setState({reschedule_fees_type_flat: !this.state.reschedule_fees_type_flat});
	// 	this.setState({reschedule_fees_type_percentage: !this.state.reschedule_fees_type_percentage});
    //  }
	//  if(name === 'reschedule_fees_type_percentage'){
	// 	this.setState({reschedule_fees_type_percentage: !this.state.reschedule_fees_type_percentage});
	// 	this.setState({reschedule_fees_type_flat: !this.state.reschedule_fees_type_flat});
	// }

      if(name === 'st_position'){
      	this.setState({st_position_checked: !this.state.st_position_checked});
      }
    }
	handleChange = (r,selOption) => {       
		if(r == 'plugin_size'){
			this.setState({selPluginSize:selOption})
			this.setState({  plugin_size : selOption.value});
		}
		if(r == 'product_sort_by'){
			this.setState({selProductSort:selOption})
			this.setState({  product_sort_by : selOption.value});
		}
    };
	
    componentDidMount() {
		var admin_id =  localStorage.getItem("admin_id");
		axios.get(apiUrl+"adminpanel/getchatmodel?admin_id="+admin_id)
		.then(res => {			
			if(res.data.status == 'success'){
				this.setState({
					faqmodelguest: res.data.faqmodelguest,
					all_models: res.data.all_models,
					faqmodeluser: res.data.faqmodeluser,
					faqmodelbroker: res.data.faqmodelbroker,
					faqmodelrehab: res.data.faqmodelrehab,
					faqmodelcompany: res.data.faqmodelcompany,
				});		
			}
		});

		const queryParameters = new URLSearchParams(window.location.search)
		const client_id = queryParameters.get("client_id");
		const code = queryParameters.get("code");


      document.title = PageTitle('Settings');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
	  let body = document.querySelectorAll("body")[0];
	if(localStorage.getItem('admin_id')){
		body.classList.remove("body-theme");
	}else{
		body.classList.add("body-theme");
	}
     }
	 
	
    handleFormSubmit = () => {
		// alert(this.validateForm())
			if(this.validateForm()){
				this.setState({Loading:true});
				
				const config = {
			        headers: {
			          'Content-Type': 'multipart/form-data'
			        }
			      };
				  
				const formPayload = this.state;

				var qs = require('qs');
				if(this.state.smtp_checked === true){
					var settings_mail_from_smtp = '1';
				}else{
					 settings_mail_from_smtp = '0';
				}
				if(this.state.stripe_live_checked === true){
					var settings_enable_live = '1';
				}else{
					 settings_enable_live = '0';
				}

				if(this.state.st_position_checked === true){
					var plugin_position = 'fixed';
				}else{
					var plugin_position = 'absolute';
				}
                var fonttype;
				if(formPayload.selectedFont[0]==undefined){
					fonttype = formPayload.selectedFont.value;
				}else{
					fonttype = formPayload.selectedFont[0].value;
				}				
				var product_layout = '';
				if(this.state.product_layout3_checked === true){
					 product_layout = '3';
				}else{
					 product_layout = '2';
				}

				var show_category = '';
				if(this.state.category_icons_yes === true){
					show_category = 'yes';
				}else{
					show_category = 'no';
				}
				
				var themeId;
				if(formPayload.selTheme[0]==undefined){
					themeId = formPayload.selTheme.value;
				}else{
					themeId = formPayload.selTheme[0].value;
				}				
				// var cancellation_fees_type = '';
				// if(this.state.cancellation_fees_type_flat === true){
				// 	cancellation_fees_type = 'flat';
				// }else{
				// 	cancellation_fees_type = 'percentage';
				// }

				// var reschedule_fees_type = '';
				// if(this.state.reschedule_fees_type_flat === true){
				// 	reschedule_fees_type = 'flat';
				// }else{
				// 	reschedule_fees_type = 'percentage';
				// }

				



				var postObject = {
					settings_id: formPayload.settings_id,
					settings_site_title:formPayload.settings_site_title,
					settings_from_name:formPayload.settings_from_name,
					settings_admin_email:formPayload.settings_admin_email,
					settings_from_email:formPayload.settings_from_email,
					settings_mailpath:formPayload.settings_mailpath,					
					site_background: formPayload.hexColor,
					smtp_host:formPayload.settings_smtp_host,
					smtp_user:formPayload.settings_smtp_user,
					smtp_pass:formPayload.settings_smtp_pass,
					smtp_port:formPayload.settings_smtp_port,
					admin_user:formPayload.settings_username,
					admin_no:formPayload.settings_mobileno,
					settings_email_footer:formPayload.settings_email_footer,
					settings_mail_from_smtp:settings_mail_from_smtp,
					settings_public_key:formPayload.settings_public_key,
					settings_product_key:formPayload.settings_product_key,					
					settings_secret_key:formPayload.settings_secret_key,					
					st_position_left:formPayload.st_position_left,
					st_position_right:formPayload.st_position_right,
					st_position_top:formPayload.st_position_top,
					st_position_bottom:formPayload.st_position_bottom,
					st_loader_text:formPayload.st_loader_text,
					st_plugin_height:(formPayload.st_plugin_height!='')?formPayload.st_plugin_height:0,
					st_plugin_left_space:formPayload.st_plugin_left_space,
					st_plugin_right_space:formPayload.st_plugin_right_space,
					st_plugin_top_space:formPayload.st_plugin_top_space,
					st_plugin_bottom_space:formPayload.st_plugin_bottom_space,
					st_plugin_ai_width:formPayload.st_plugin_ai_width,
					//st_loader_image:formPayload.st_loader_image,
					welcome_invite_friends:formPayload.welcome_invite_friends,
					// st_invite_image:formPayload.st_invite_image,
					// st_email_logo:formPayload.st_email_logo,
					font 		  : fonttype,
					//plugin_position: plugin_position,
					st_position: formPayload.st_position,
					google_analystic_code: formPayload.google_analystic_code,
					removeId: formPayload.removeID,
					settings_faq_guest_model_id:formPayload.selectedfaqmodelguestval,
					// aichat_type:formPayload.aichat_type,
					// aichat_code:formPayload.aichat_code,
					// ai_fine_tune_model_id: formPayload.ai_fine_tune_model_id,
					//np_theme: formPayload.np_theme,
					//dashboardview: formPayload.dashboard_view,
					plugin_size: formPayload.plugin_size,
					product_sort_by: formPayload.product_sort_by,
					display_tab: formPayload.display_tab,
					st_product_image: formPayload.st_product_image,
					st_product_line: formPayload.st_product_line,
					st_line_color: formPayload.st_line_color,
					primary_font:formPayload.primary_font,
					main_tab_font_size:formPayload.main_tab_font_size,
					menu_font_size:formPayload.menu_font_size,
					lineHeight:formPayload.line_height,
					st_varient_id:formPayload.st_varient_id,
					settings_task_model : formPayload.selectedallmodelvalue,
					chat_ai_key:formPayload.chat_ai_key,
					tracking_limit:formPayload.tracking_limit,
					plugin_close_content:formPayload.plugin_close_content,
					upgrade_content:formPayload.upgrade_content,
					google_conversation_code:formPayload.google_conversation_code,
					invite_friends:formPayload.invite_friends,
					st_earning_claims_content:formPayload.st_earning_claims_content,
					st_invite_claim_eligible:formPayload.st_invite_claim_eligible,
					st_invite_earning_amount:formPayload.st_invite_earning_amount,
					st_product_image_size:formPayload.st_product_image_size,
					shortcutBoxShadowDet:formPayload.shortcutBoxShadowDet,
					pluginOuterSpaceChecked:formPayload.pluginOuterSpaceChecked,
					// pluginRadius:formPayload.pluginRadius,
					// dropdownRadius:formPayload.dropdownRadius,
					// inputRadius:formPayload.inputRadius,
					// textareaRadius:formPayload.textareaRadius,
					// st_aisidebar_width: formPayload.st_aisidebar_width,
					// st_aisidebar_collapsed_width: formPayload.st_aisidebar_collapsed_width,
					// st_aisidebar_icon_width: formPayload.st_aisidebar_icon_width,
					// fontDetails:JSON.stringify(formPayload.fontDetails),
					// shadow: JSON.stringify(this.state.shadows),

					loader_image:formPayload.loader_image,
					invite_image:formPayload.invite_image,
					mail_image:formPayload.mail_image,
					themeId:themeId,
				};
	
				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}
			/* 	var domains = formPayload.domainSets
				for(let i in domains){
					formData.append('domainName[]',domains[i]['domain_name'])
				} */
				

				var domains = formPayload.domainSets;

				for(let i in domains){

					if(domains[i]['domain_id'] ==  'undefined'){
						formData.append('domainName['+ i + '][domain_id]','null')		
					}else if(domains[i]['domain_id'] !==  undefined && domains[i]['domain_id'] !==  ''){
						formData.append('domainName['+ i + '][domain_id]',domains[i]['domain_id'])
					}

					formData.append('domainName['+ i + '][domain_name]',domains[i]['domain_name'])
					formData.getAll('domainName');
				}
				axios.post(apiUrl+"adminpanel/settingsave",formData,config).then(res => {
	
					if(res.data.results){
						this.setState({Loading:false});
					        	const formpayload = res.data.results;
								$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
								this.setState({settings_id:formpayload.settings_id});
								this.setState({settings_site_title:formpayload.settings_site_title});
								this.setState({settings_from_name:formpayload.settings_from_name});
								this.setState({settings_admin_email:formpayload.settings_admin_email});
								this.setState({settings_from_email:formpayload.settings_from_email});
								this.setState({settings_mailpath:formpayload.settings_mailpath});
								this.setState({settings_company_address:formpayload.settings_company_address});
								this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
								this.setState({settings_smtp_host:formpayload.settings_smtp_host});
								this.setState({settings_smtp_user:formpayload.settings_smtp_user});
								this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
								this.setState({settings_smtp_port:formpayload.settings_smtp_port});
								this.setState({settings_username:formpayload.settings_username});
								this.setState({settings_mobileno:formpayload.settings_mobileno});
								this.setState({settings_email_footer:formpayload.settings_email_footer});
								this.setState({hexColor:formpayload.settings_site_background_color});
								this.setState({settings_public_key:formpayload.settings_public_key});
								this.setState({settings_product_key:formpayload.settings_product_key});
								this.setState({setting_goal_amount:formpayload.setting_goal_amount});
								this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
								this.setState({settings_secret_key:formpayload.settings_secret_key});
								this.setState({settings_embedcode:formpayload.settings_embedcode});
								this.setState({settings_access_code:formpayload.access_code});
								this.setState({st_position_left:formpayload.st_position_left});
								this.setState({st_position_right:formpayload.st_position_right});
								this.setState({st_position_top:formpayload.st_position_top});
								this.setState({st_position_bottom:formpayload.st_position_bottom});
								this.setState({st_plugin_height:formpayload.st_plugin_height});
								this.setState({st_plugin_left_space:formpayload.st_plugin_left_space});
								this.setState({st_plugin_right_space:formpayload.st_plugin_right_space});
								this.setState({st_plugin_top_space:formpayload.st_plugin_top_space});
								this.setState({st_plugin_bottom_space:formpayload.st_plugin_bottom_space});
								this.setState({st_plugin_ai_width:formpayload.st_plugin_ai_width});
								this.setState({st_loader_text:formpayload.st_loader_text});
								this.setState({st_loader_image:formpayload.st_loader_image});
								this.setState({welcome_invite_friends:formpayload.welcome_invite_friends});
								this.setState({st_invite_image:formpayload.st_invite_image});
								this.setState({st_email_logo:formpayload.st_email_logo});
								this.setState({st_inventory_count:formpayload.st_inventory_count});
								this.setState({domainSets: formpayload.domainSets});
								this.setState({settings_commision_amount: formpayload.settings_commision_amount});
								this.setState({merchant_commision_to_broker: formpayload.merchant_commision_to_broker});	
								this.setState({rehab_purchase_count: formpayload.rehab_purchase_count});																
								this.setState({header_cat_limit: formpayload.header_cat_limit});
								this.setState({domain_count: formpayload.domain_count});
								this.setState({dashboard_view: formpayload.dashboardview});
								this.setState({plugin_size: formpayload.plugin_size});
								this.setState({product_sort_by: formpayload.product_sort_by});
								this.setState({display_tab: formpayload.display_tab});
								this.setState({st_product_image: formpayload.st_product_image});
								this.setState({st_product_line: formpayload.st_product_line});
								this.setState({st_line_color: formpayload.st_line_color});
								this.setState({primary_font:formpayload.primary_font});
								this.setState({main_tab_font_size:formpayload.main_tab_font_size});
								this.setState({menu_font_size:formpayload.menu_font_size});
								this.setState({line_height:formpayload.lineHeight});
								this.setState({chat_ai_key:formpayload.chat_ai_key});
								this.setState({tracking_limit:formpayload.tracking_limit});
								this.setState({plugin_close_content:formpayload.plugin_close_content});
								this.setState({upgrade_content:formpayload.upgrade_content});
								this.setState({google_conversation_code:formpayload.google_conversation_code});
								this.setState({invite_friends:formpayload.invite_friends});
								this.setState({st_earning_claims_content:formpayload.st_earning_claims_content});
								this.setState({st_invite_claim_eligible:formpayload.st_invite_claim_eligible});
								this.setState({st_invite_earning_amount:formpayload.st_invite_earning_amount});
								this.setState({st_product_image_size:formpayload.st_product_image_size});
								// this.setState({pluginRadius:formpayload.pluginRadius});
								// this.setState({dropdownRadius:formpayload.dropdownRadius});
								// this.setState({inputRadius:formpayload.inputRadius});
								// this.setState({textareaRadius:formpayload.textareaRadius});
								this.setState({shortcutBoxShadowDet:formpayload.shortcutBoxShadowDet});
								// this.setState({st_aisidebar_width: formpayload.st_aisidebar_width});
								// this.setState({st_aisidebar_collapsed_width: formpayload.st_aisidebar_collapsed_width});
								// this.setState({st_aisidebar_icon_width: formpayload.st_aisidebar_icon_width});
								
								if(formpayload.settings_faq_user_model_id!== 'null' && formpayload.settings_faq_user_model_id !== ''){
									this.setState({selectedfaqmodeluser: {value:formpayload.settings_faq_user_model_id, label:formpayload.settings_faq_user_model_id},selectedfaqmodeluserval:formpayload.settings_faq_user_model_id });
								}
								if(formpayload.settings_faq_guest_model_id!== 'null' && formpayload.settings_faq_guest_model_id !== ''){
									this.setState({selectedfaqmodelguest: {value:formpayload.settings_faq_guest_model_id, label:formpayload.settings_faq_guest_model_id},selectedfaqmodelguestval:formpayload.settings_faq_guest_model_id});
								}
								if(formpayload.settings_faq_company_model_id!== 'null' && formpayload.settings_faq_company_model_id !== ''){
									this.setState({selectedfaqmodelcompany: {value:formpayload.settings_faq_company_model_id, label:formpayload.settings_faq_company_model_id},selectedfaqmodelcompanyval:formpayload.settings_faq_company_model_id });
								}
								if(formpayload.settings_faq_rehab_model_id!== 'null' && formpayload.settings_faq_rehab_model_id !== ''){
									this.setState({selectedfaqmodelrehab: {value:formpayload.settings_faq_rehab_model_id, label:formpayload.settings_faq_rehab_model_id},selectedfaqmodelrehabval:formpayload.settings_faq_rehab_model_id });
								}
								this.setState({aichat_type: formpayload.ai_model_type});
								this.setState({aichat_code: formpayload.aichat_code});
								this.setState({ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id});


								if( formpayload.google_analystic_code !== 'null'){
									this.setState({google_analystic_code: formpayload.google_analystic_code});
								}else{
									this.setState({google_analystic_code: ''});
								}

								if(formpayload.settings_mail_from_smtp === '1'){
									this.setState({smtp_checked: true});
								}else{
									this.setState({smtp_checked: false});
								}
								if(formpayload.pluginOuterSpaceChecked === 'true'){
									this.setState({pluginOuterSpaceChecked: true});
								}else{
									this.setState({pluginOuterSpaceChecked: false});
								}


								// if(formpayload.st_plugin_position === 'fixed'){
								// 	this.setState({st_position_checked: true });
								// }else{
								// 	this.setState({st_position_checked: false});
								// }
								this.setState({st_position: formpayload.st_plugin_position});

								if(formpayload.product_layout === '2'){
									this.setState({product_layout2_checked: true });
									this.setState({product_layout3_checked: false});
								}else{
									this.setState({product_layout3_checked: true});
									this.setState({product_layout2_checked: false });
								}

								if(formpayload.enable_live === '1'){
									this.setState({stripe_checked: true});
								}else{
									this.setState({stripe_checked: false});
								}

								if(formpayload.show_category_icons === 'yes'){
									this.setState({category_icons_yes: true });
									this.setState({category_icons_no: false});
								}else{
									this.setState({category_icons_no: true});
									this.setState({category_icons_yes: false });
								}
									scrollToTop();

									setTimeout(
										function() {
											$('.success_message').html('');
										}
										.bind(this),
										6000
										);
				    }
						 
				 });
			}
	}

	validateForm() {

		const {settings_commision_amount,settings_id,settings_site_title,settings_from_name,settings_admin_email,settings_from_email,settings_company_address,settings_commission_percentage,settings_smtp_host,settings_smtp_user,settings_smtp_pass,settings_smtp_port,settings_username,settings_mobileno,settings_email_footer,settings_public_key,settings_product_key,setting_goal_amount,supporter_additional_fee,settings_secret_key,settings_embedcode,selectedFont,
			payment_form,domainSets, primary_font, main_tab_font_size, menu_font_size, chat_ai_key, tracking_limit, plugin_close_content, upgrade_content, google_conversation_code, invite_friends, st_earning_claims_content, st_invite_claim_eligible, st_invite_earning_amount, st_position, st_position_bottom, st_position_top, st_position_right, st_position_left, selTheme
		} = this.state;

		

		const nameRegex = /^[A-Za-z\s.]+$/;
		let errors = 0;

		// const fontDetails = [...this.state.fontDetails];
		// for (let index = 0; index < fontDetails.length; index++) {			
		// 	if(fontDetails[index].FontType == "") {
		// 		fontDetails[index].FontTypeCheck = "Type is required";
		// 	  errors++;
		// 	}else{
		// 		fontDetails[index].FontTypeCheck = "";
		// 	}
		// }
		// this.setState({ fontDetails });

      	//let formIsValid = true;
		if (!settings_site_title) { 
			errors++;
			$('.errorsettings_site_title').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_site_title){
			if (!nameRegex.test(settings_site_title)) {
				errors++;
			$('.errorsettings_site_title').html('<span class="errorspan">Please enter the valid site name</span>');
			}else{
				$('.errorsettings_site_title').html('');
			}
			
		}
		if (!domainSets.length>0) { 
			
			errors++;
			$('.errorsettings_domain').html('<span class="errorspan">Please add atleast one domain</span>');
		}else{		
			$('.errorsettings_domain').html('');
		}
		if (!settings_from_name) { 
			errors++;
			$('.errorsettings_from_name').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_from_name){
			if (!nameRegex.test(settings_from_name)) {
				errors++;
			$('.errorsettings_from_name').html('<span class="errorspan">Please enter the valid from name</span>');
			}else{
				$('.errorsettings_from_name').html('');
			}
			
		}

		if (!settings_admin_email) {
			errors++; 
			$('.errorsettings_admin_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_admin_email){
			var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
			if (reg.test(settings_admin_email)) 
			{
			  $('.errorsettings_admin_email').html('');
			}else{
			//   errors++;
			  
			// $('.errorsettings_admin_email').html('<span class="errorspan">Please enter valid email address</span>');
			}
			  
			
			}
		if (!settings_from_email) {
			errors++; 
			$('.errorsettings_from_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_from_email){
			var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
			if (reg.test(settings_from_email)) 
			{
			  $('.errorsettings_from_email').html('');
			}else{
			//   errors++;
			  
			// $('.errorsettings_from_email').html('<span class="errorspan">Please enter valid email address</span>');
			}
			  
			
			}
		

		if (!settings_mobileno) { 
			errors++;
			$('.errorsettings_mobileno').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_mobileno){	
			var pattern = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
			var indiapattern =/^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
			   if (pattern.test(settings_mobileno)) {
			   $('.errorsettings_mobileno').html('');
			   }else if(indiapattern.test(settings_mobileno)){
			   $('.errorsettings_mobileno').html('');
			   }else{
					errors++;
			   
					$('.errorsettings_mobileno').html('<span class="errorspan">Please enter valid contact</span>');
				  }
			   }


		

		if (!settings_email_footer) { 
			errors++;
			$('.errorsettings_email_footer').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_company_address){
			$('.errorsettings_email_footer').html('');
		}
		if (!settings_public_key) {
			errors++;
			$('.errorsettings_public_key').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_public_key){
			$('.errorsettings_public_key').html('');
		}
		
		// if (!settings_product_key) {
		// 	errors++;
		// 	$('.errorsettings_product_key').html('<span class="errorspan">Please fill the field</span>');
		// }else if(settings_product_key){
		// 	$('.errorsettings_product_key').html('');
		// }
		
		if (!settings_secret_key) {
			errors++;
			$('.errorsettings_secret_key').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_secret_key){
			$('.errorsettings_secret_key').html('');
		}
		if (!primary_font) {
			errors++;
			$('.errorprimary_font').html('<span class="errorspan">Please fill the field</span>');
		}else if(primary_font){
			$('.errorprimary_font').html('');
		}
		if (!main_tab_font_size) {
			errors++;
			$('.errormain_tab_font_size').html('<span class="errorspan">Please fill the field</span>');
		}else if(main_tab_font_size){
			$('.errormain_tab_font_size').html('');
		}
		if (!menu_font_size) {
			errors++;
			$('.errormenu_font_size').html('<span class="errorspan">Please fill the field</span>');
		}else if(menu_font_size){
			$('.errormenu_font_size').html('');
		}

		if (st_position == 'fixed') {			
			if (!st_position_top) {
				errors++;
				$('.errorsettings_st_position_top').html('<span class="errorspan">Please fill the field</span>');
			}else if(st_position_top){
				$('.errorsettings_st_position_top').html('');
			}	
			if (!st_position_bottom) {
				errors++;
				$('.errorsettings_st_position_bottom').html('<span class="errorspan">Please fill the field</span>');
			}else if(st_position_bottom){
				$('.errorsettings_st_position_bottom').html('');
			}	
			if (!st_position_left && !st_position_right) {
				errors++;
				$('.errorsettings_st_position_left').html('<span class="errorspan">Please enter either the left or right field.</span>');
			}else if (st_position_left && st_position_right) {
				errors++;
				$('.errorsettings_st_position_left').html('<span class="errorspan">Please enter either the left or right field.</span>');
			}else{
				$('.errorsettings_st_position_left').html('');
			}	
		} 
		else if (st_position == 'absolute') {			
			
			if (!st_position_top && !st_position_bottom) {
				errors++;
				$('.errorsettings_st_position_top').html('<span class="errorspan">Please enter either the top or bottom field.</span>');
			}else if (st_position_top && st_position_bottom) {
				errors++;
				$('.errorsettings_st_position_top').html('<span class="errorspan">Please enter either the top or bottom field.</span>');
			}else{
				$('.errorsettings_st_position_top').html('');
			}	

			if (!st_position_left && !st_position_right) {
				errors++;
				$('.errorsettings_st_position_left').html('<span class="errorspan">Please enter either the left or right field.</span>');
			}else if (st_position_left && st_position_right) {
				errors++;
				$('.errorsettings_st_position_left').html('<span class="errorspan">Please enter either the left or right field.</span>');
			}else {
				$('.errorsettings_st_position_left').html('');
			}	
		} 

		if(!selTheme){
			errors++;
			$('.errortheme').html('<span class="errorspan">Please select the theme.</span>');
		}else{
			if(selTheme.value == 0 && selTheme.value == ''){
				errors++;
				$('.errortheme').html('<span class="errorspan">Please select the theme.</span>');
			} else{
				$('.errortheme').html('');
			}
		}	

		if(errors>0) {
			setTimeout(function () {
				scrollToTopValidate();
			}, 100);
			return false;
		}
		else {
		return true;
		}
    }

    componentWillReceiveProps(Props){
		

    	  	if(Props.updatesetting !== this.props.updatesetting){ 
				
			
    		if(Object.keys(Props.updatesetting).length > 0){
				
    			this.setState({ Loading: false });

    			const formpayload = Props.updatesetting[0].results;
				
    			$('.success_message').html('<div class="status_sucess"><h3>'+ Props.updatesetting[0].message+'</h3></div>');
				this.setState({fontDetails:Props.updatesetting[0].setting_font_varients});
    			this.setState({settings_id:formpayload.settings_id});
    			this.setState({settings_site_title:formpayload.settings_site_title});
    			this.setState({settings_from_name:formpayload.settings_from_name});
    			this.setState({settings_admin_email:formpayload.settings_admin_email});
    			this.setState({settings_from_email:formpayload.settings_from_email});
    			this.setState({settings_mailpath:formpayload.settings_mailpath});
    			this.setState({settings_company_address:formpayload.settings_company_address});
    			this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
    			this.setState({settings_smtp_host:formpayload.settings_smtp_host});
    			this.setState({settings_smtp_user:formpayload.settings_smtp_user});
    			this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
    			this.setState({settings_smtp_port:formpayload.settings_smtp_port});
    			this.setState({settings_username:formpayload.settings_username});
    			this.setState({settings_mobileno:formpayload.settings_mobileno});
    			this.setState({settings_email_footer:formpayload.settings_email_footer});
    			this.setState({hexColor:formpayload.settings_site_background_color});
    			this.setState({settings_public_key:formpayload.settings_public_key});
				this.setState({settings_product_key:formpayload.settings_product_key});
				this.setState({setting_goal_amount:formpayload.setting_goal_amount});
				this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
    			this.setState({settings_secret_key:formpayload.settings_secret_key});
				this.setState({settings_embedcode:formpayload.settings_embedcode});
				this.setState({settings_access_code:formpayload.access_code});
				this.setState({st_position_left:formpayload.st_position_left});
				this.setState({st_position_right:formpayload.st_position_right});
				this.setState({st_position_top:formpayload.st_position_top});
				this.setState({st_position_bottom:formpayload.st_position_bottom});
				this.setState({st_plugin_height:formpayload.st_plugin_height});
				this.setState({st_plugin_left_space:formpayload.st_plugin_left_space});
				this.setState({st_plugin_right_space:formpayload.st_plugin_right_space});
				this.setState({st_plugin_top_space:formpayload.st_plugin_top_space});
				this.setState({st_plugin_bottom_space:formpayload.st_plugin_bottom_space});
				this.setState({st_plugin_ai_width:formpayload.st_plugin_ai_width});
				this.setState({st_loader_text:formpayload.st_loader_text});
				this.setState({st_loader_image:formpayload.st_loader_image});
				this.setState({welcome_invite_friends:formpayload.welcome_invite_friends});
				this.setState({st_invite_image:formpayload.st_invite_image});
				this.setState({st_email_logo:formpayload.st_email_logo});
				this.setState({st_inventory_count:formpayload.st_inventory_count});
				this.setState({domainSets: formpayload.domainSets});
				this.setState({settings_commision_amount: formpayload.settings_commision_amount});
				this.setState({header_cat_limit: formpayload.header_cat_limit});
				this.setState({domain_count: formpayload.domain_count});
				this.setState({dashboard_view: formpayload.dashboardview});
				this.setState({plugin_size: formpayload.plugin_size});
				this.setState({product_sort_by: formpayload.product_sort_by});
				this.setState({display_tab: formpayload.display_tab});
				this.setState({st_product_image: formpayload.st_product_image});
				this.setState({st_product_line: formpayload.st_product_line});
				this.setState({st_line_color: formpayload.st_line_color});
				// this.setState({st_aisidebar_width: formpayload.st_aisidebar_width});
				// this.setState({st_aisidebar_collapsed_width: formpayload.st_aisidebar_collapsed_width});
				// this.setState({st_aisidebar_icon_width: formpayload.st_aisidebar_icon_width});
				
				if( formpayload.google_analystic_code !== 'null'){
					this.setState({google_analystic_code: formpayload.google_analystic_code});
				}else{
					this.setState({google_analystic_code: ''});
				}

    			if(formpayload.settings_mail_from_smtp === '1'){
    				this.setState({smtp_checked: true});
    			}else{
    				this.setState({smtp_checked: false});
    			}
    			if(formpayload.pluginOuterSpaceChecked === 'true'){
    				this.setState({pluginOuterSpaceChecked: true});
    			}else{
    				this.setState({pluginOuterSpaceChecked: false});
    			}


    			// if(formpayload.st_plugin_position === 'fixed'){
    			// 	this.setState({st_position_checked: true });
    			// }else{
    			// 	this.setState({st_position_checked: false});
    			// }
				this.setState({st_position: formpayload.st_plugin_position },()=>{
					if(formpayload.st_plugin_position =='absolute'){
						$('.d-height').removeClass('d-none');
					}else{
						$('.d-height').addClass('d-none');
					}
				});

    			if(formpayload.product_layout === '2'){
    				this.setState({product_layout2_checked: true });
    				this.setState({product_layout3_checked: false});
    			}else{
    				this.setState({product_layout3_checked: true});
    				this.setState({product_layout2_checked: false });
    			}

    			if(formpayload.enable_live === '1'){
    				this.setState({stripe_checked: true});
    			}else{
    				this.setState({stripe_checked: false});
    			}

				if(formpayload.show_category_icons === 'yes'){
    				this.setState({category_icons_yes: true });
    				this.setState({category_icons_no: false});
    			}else{
    				this.setState({category_icons_no: true});
    				this.setState({category_icons_yes: false });
    			}
    				scrollToTop();

    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
    		}
    	}
    

    	var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id)
			
			.then(res => {
				if(res.data.status == 'success'){
				
					this.setState({
						fonttype: res.data.fontlist
					})
				
				}else{
				//console.log("test")
				}
			});

	}

	setselectedtheme(sel) {
		// Map input array to objects with label and value
		// const theme = sel.map((themeData, index) => ({
		// 	label: themeData.label,
		// 	value: themeData.value,
		// }));		
		this.setState({ selTheme: { value: sel.value, label: sel.label }, theme_id : sel.value });
	}

	setselectedvalue(selectsers){
		
	    const fontArray = selectsers.map((fonttype, index) => ({
	     id: index,
	     name: fonttype,
	    }));
    // Dynamically create select list
    let fonts = [];
    fontArray.map(item =>
    fonts.push({ label: item.name.label, value: item.name.value }),
    );
    this.setState({selectedFont : fonts})
  }
  setselectedvariants(selectvarients=null){
		
	// const fontVariantArray = selectvarients.map((fontvar, index) => ({
	//  id: index,
	//  name: fontvar,
	// }));
	// Dynamically create select list
	//let fonts = [];	
	selectvarients = (selectvarients != null ? selectvarients : {});
	if (Object.keys(selectvarients).length > 0) {	
	var listings = selectvarients.map((item, index) => {
		//fonts.push({ variant_id: item.name.id, variant_name: item.name.varient_name }),
		//console.log(item.id, '--isChecked')
		if(item.isChecked == 'checked'){
			this.state.st_varient_id.push(item.id);
		}
		//this.setState({ st_varient_id: [...this.state.st_varient_id, item.id] });
		return (						
			<div className="form-group" key={index}>
				<input 
				onChange={this.handleCheckBoxChange.bind(this)}
				type="checkbox"  name="st_varients" 
				value={item.id}
				defaultChecked={item.isChecked}
				/>
				<span>{item.varient_name+' '+item.variant_weight}</span>
			</div>									
		);				
	});
	} else{
		var listings = '';
		this.setState({st_varient_id: []})
	}
	this.setState({selectedFontVariant : listings})
}

handleCheckBoxChange = (e) => {
	const isChecked = e.target.checked;
	const isCheckedVal = e.target.value;
	
	if(isChecked){
		this.setState({ st_varient_id: [...this.state.st_varient_id, e.target.value] });
	} else{
		// setSelectedId(selectedIds.filter(id=>id !== checkedId))
		// const index = this.state.st_varient_id.indexOf(e.target.value);
		// this.state.st_varient_id.splice(index,1);
		this.setState({ st_varient_id: this.state.st_varient_id.filter(id=>id !== e.target.value) });
	}
};

	handleClick = () => {
	this.setState({ displayColorPicker: !this.state.displayColorPicker })
	};

	handleClose = () => {
	this.setState({ displayColorPicker: false })
	};

	/* handleChange = (color) => {
	this.setState({hexColor : color.hex})
	this.setState({ color: color.rgb })
	}; */

	 copyCodeToClipboard(event){
		event.preventDefault;
		const el = this.textArea
		el.select()
		document.execCommand("copy")
   }


   writeText = () => {
	 
	$('.copied_title').html('<span class=""><h3>Copied</h3></span>');

	//onClick={() =>  navigator.clipboard.writeText(tester)}
	//let test1 = this.state.settings_access_code;
	let test1 = 752807;
	
	//let  tester =	'<script src="http://connect.uxt.design/assets/js/plugin.js"></script> <div data-client="'+test1+'"  id="uxt_container"></div>';
	let  tester =	'<script src="http://dev.uxt.design/assets/js/plugin.js"></script> <div data-client="'+test1+'"  id="uxt_container"></div>';
	 navigator.clipboard.writeText(tester);
	setTimeout(
		function() {
			$('.copied_title').html('');
			$('.copied_title').hide();
		}
		.bind(this),
		3000
		);
		
    }

/*    myCallback = (domainsets) => {
   	//console.log(domainsets,'domainsets')
    this.setState({domainSets: domainsets});
  }; */

  

   myCallback = (domainsets,domainID,domain_count) => {
    this.setState({domainSets: domainsets,removeID: domainID,domain_count:domain_count});
   };
   handleChangeFont = selectedFont => {
      this.setState({ selectedFont});
      this.setState({ fontvalue : selectedFont.value });
      if(selectedFont.value === ''){
        //$('.errorfont').html('<span class="errorspan">Please select the font</span>');
      }else{
		axios.get(apiUrl+'adminpanel/getfont_varient?font_id='+selectedFont.value)
			.then(res => {
				if(res.data.status == 'success'){					
					//if(res.data.fontvarientlist!== '' && res.data.fontvarientlist!== null){
						this.setselectedvariants(res.data.fontvarientlist);
					//}
				
				}else{
				//console.log("test")
					this.setselectedvariants(res.data.fontvarientlist);
				}
			});
      	 $('.errorfont').html('');
      }
   }

   handleChangeAimodeluser = selectedfaqmodeluser => {
	this.setState({ selectedfaqmodeluser});
	this.setState({ selectedfaqmodeluserval : selectedfaqmodeluser.value });	
	}

	handleChangeAllmodelguest = selectedallmodel => {
		this.setState({ selectedallmodel});
		this.setState({ selectedallmodelvalue : selectedallmodel.value });	
		}

	
	handleChangeAimodelguest = selectedfaqmodelguest => {
		this.setState({ selectedfaqmodelguest});
		this.setState({ selectedfaqmodelguestval : selectedfaqmodelguest.value });	
	}

	handleChangeAimodelcompany = selectedfaqmodelcompany => {
		this.setState({ selectedfaqmodelcompany});
		this.setState({ selectedfaqmodelcompanyval : selectedfaqmodelcompany.value });	
	}
	handleChangeAimodelrehab = selectedfaqmodelrehab => {
		this.setState({ selectedfaqmodelrehab});
		this.setState({ selectedfaqmodelrehabval : selectedfaqmodelrehab.value });	
	}
	
handleSave = () => {
	this.setState({Loading:true});
	const config = {
		headers: {
		  'Content-Type': 'multipart/form-data'
		}
	  };
	const formPayload = this.state;
	var qs = require('qs');
	var postObject = {
		
		settings_id: formPayload.settings_id,
		admin_id: localStorage.getItem('admin_id'),
		aifeed:this.state.description,
		type : formPayload.type,
		imp_cate : 8
		
	};

	let formData = new FormData();
	for(let k in postObject) {
		formData.append(k, postObject[k]);
	}
	axios.post(apiUrl+"faq/settingaifeedsave",formData,config).then(res => {
		if(res.data.results){
		}
			 
	 }); 

}


// ================================font start ====================
addFunc = e => {
	this.setState(prevState => ({
	  fontDetails: [
		...prevState.fontDetails,
		{
		  index: Math.random(),
		  FontType: "",
		  FontSize:'',
		  FontWeight:'',
		  letterSpacing:'',
		  lineHeight:'',
		  TopSpace:'',
		  BottomSpace:'',
		  radius:'',
		  varient_id : "",
		}
	  ]
	}));
};
deleteFunc(record) {
	this.setState({
	  fontDetails: this.state.fontDetails.filter(r => r !== record)
	});
}
Capitalize(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
}
addMoreFunc = (e) => {	
	return this.state.fontDetails.map((val, idx) => {
		
		let FontType = `FontType${idx}`,
		fontWeight = `fontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		radius = `radius${idx}`,
		errorfile = `errorfile${idx}`;
		return ( <>
		  <div className="form-row mb-0" key={val.index}>
		  		<div className='form-left'>			
				<div className="form-group"  >					
					<h4 className='fs-5'>
						{/* Apply font : */}

						{/* Font Apply to {this.Capitalize(val.fontType)} */}
						{(val.listName)} :
						
						
						</h4>	
					{/* <div className='d-flex align-items-center gap-3'>					
					<select name="FontType" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
						<option value="" className="fontVarientName" > Select Type</option>
						<option value="PrimaryFont" className="fontVarientName" selected={val.FontType=='PrimaryFont'?true:false} > Primary Font</option>
						<option value="mainTab" className="fontVarientName" selected={val.FontType=='mainTab'?true:false} > MainTab</option>
						<option value="sideMenu" className="fontVarientName" selected={val.FontType=='sideMenu'?true:false} > SideMenu</option>
						<option value="title" className="fontVarientName" selected={val.FontType=='title'?true:false} > Title</option>
						<option value="subTitle" className="fontVarientName" selected={val.FontType=='subTitle'?true:false}> SubTitle</option>
						<option value="button" className="fontVarientName"selected={val.FontType=='button'?true:false} > Button</option>
						<option value="smButton" className="fontVarientName" selected={val.FontType=='smButton'?true:false}> SmallButton</option>
						<option value="lgButton" className="fontVarientName" selected={val.FontType=='lgButton'?true:false}> LargeButton</option>										
					</select>						
					{idx === 0 ? (
					<span className="add_font_varients cursor-pointer"  onClick={() => this.addFunc()}><i class="fa fa-plus-circle fa-1x"></i></span> ) : 
					<span className="btn_remove cursor-pointer" onClick={() => this.deleteFunc(val)} ><i class="fa fa-trash fa-1x"></i></span>
					}	
					</div>	 */}
					<div>{val.FontTypeCheck}</div>
				</div>
				</div>
			</div>
			<div className="form-row mb-5" key={val.index}>	
				{this.varientField(val.font_id, val.fontFamily, val.fontType,idx,val,val.index)}
		  	</div>
		  </>
		);
	  });
}
// varientField = (FontId, FontFamily, FontType,idx,val)=>{
// 	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
// 	id: index,
// 	name: fonttype,
// 	}));
// 	// Dynamically create select list
// 	let fonts = [];
// 	fontArray.map(item =>
// 		fonts.push({ label: item.name.label, value: item.name.value }),
// 	);

// 	let fontWeight = `fontWeight${idx}`,
// 		FontSize = `FontSize${idx}`,
// 		FontIndId = `FontId${idx}`,
// 		letterSpacing = `letterSpacing${idx}`,
// 		lineHeight = `lineHeight${idx}`,
// 		TopSpace = `TopSpace${idx}`,
// 		BottomSpace = `BottomSpace${idx}`,
// 		errorfile = `errorfile${idx}`
// 		//if(FontType !=='smButton' && FontType!=='lgButton'){
// 		return(
// 			<>
// 			<div className="form-left">
// 				<div className="form-group">
// 					<label>Font Family  :</label>
// 					<div>																
// 						{/* <Select 
// 							options={fonts}  
// 							value={FontFamily}
// 							//onChange={this.handleChangeFont}
// 							placeholder="Select Font Type" 
// 							name="FontFamily" 
// 							id={FontIndId} 
// 							data-id={idx} 								
// 							onChange={(e) => this.handleFileChange(e, idx)}
// 						/> */}

// 						<select name="font_id" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>

// 						<option value="" className="fontFamilyId" > Select Font</option>						
// 						{fonts.map((option) => (
// 						<option key={option.value} value={option.value}  selected={val.font_id==option.value?true:false}>
// 							{option.label}
// 						</option>
// 						))}
// 						</select>	
// 						<div className={errorfile}></div> 						
// 					</div>
// 				</div>	
// 			</div>
// 			<div className="form-right">
// 				<div className="form-group">
// 					<label>Font Variant :</label>
// 					<div>
// 						<select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>

// 						<option value="" className="fontVarientName" > Select Variant</option>
// 						<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
// 						<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
// 						<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
// 						<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
// 						<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
// 						<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
// 						<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
// 						<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
										
// 						</select>	


									
// 						<div className={errorfile}></div> 
// 					</div>
// 				</div>	
// 			</div>	
// 			<div className="form-left">
// 				<div className="form-group">
// 					<label>Font Size  :</label>
// 					<div>
// 						<input type="text" name="fontSize" 
// 						onChange={(e) => this.handleFileChange(e, idx)} 
// 						//onChange={this.onFileChange}
// 						value={val.fontSize}

// 						data-id={idx}
// 						id={FontSize}    /> 
									
// 						<div className={errorfile}></div> 
// 					</div>
// 				</div>	
// 			</div>
// 			{(FontType =='smallbutton' || FontType=='largebutton') ?
// 				<>
// 				<div className="form-left">
// 					<div className="form-group">
// 						<label>Top Space :</label>
// 						<div>
// 							<input type="text" name="topSpace" 
// 							onChange={(e) => this.handleFileChange(e, idx)} 
// 							value={val.topSpace}
// 							data-id={idx}
// 							id={TopSpace}    /> 
										
// 							<div className={errorfile}></div> 
// 						</div>
// 					</div>	
// 				</div>
// 				<div className="form-right">
// 					<div className="form-group">
// 						<label>Bottom Space :</label>
// 						<div>
// 							<input type="text" name="bottomSpace" 
// 							onChange={(e) => this.handleFileChange(e, idx)} 
// 							value={val.bottomSpace}
// 							data-id={idx}
// 							id={BottomSpace}    /> 									
// 							<div className={errorfile}></div> 
// 						</div>
// 					</div>	
// 				</div>	
// 				</>
// 			 	: '' 
// 			}
// 			</>);
// 		//}
// }

	varientField = (FontId, FontFamily, FontType,idx,val,selIndex)=>{
		//console.log(FontType);
		
		//console.log('done');
		const fontArray = this.state.fonttype.map ((fonttype, index) => ({
		id: index,
		name: fonttype,
		}));
		// Dynamically create select list
		let fonts = [];
		fontArray.map(item =>
			fonts.push({ label: item.name.label, value: item.name.value , fontStyles: item.name.tf_fontStyles, typeIs: item.name.tf_font_type }),
		);

		//console.log(fontArray);

		let fontWeight = `fontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		FontIndId = `FontId${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		radius = `radius${idx}`,
		errorfile = `errorfile${idx}`
		//if(FontType !=='smallButton' && FontType!=='largeButton'){
		return(
			<>
			<div className="form-left">
				<div className="form-group">
					<label>Font Family  :</label>
					<div>																
						{/* <Select 
							options={fonts}  
							value={FontFamily}
							//onChange={this.handleChangeFont}
							placeholder="Select Font Type" 
							name="FontFamily" 
							id={FontIndId} 
							data-id={idx} 								
							onChange={(e) => this.handleFileChange(e, idx)}
						/> */}

						<select name="font_id" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx,selIndex)}>

						<option value="" className="fontFamilyId" > Select Font</option>						
						{fonts.map((option) => (
						<option key={option.value} value={option.value}  selected={val.font_id==option.value?true:false}>
							{option.label}
						</option>
						))}
						</select>	
						<div className={errorfile}></div> 						
					</div>
				</div>	
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Font Variant :</label>
					<div>
						 <select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>

						<option value="" className="fontVarientName" > Select Variant</option>
						<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
						<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
						<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
						<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
						<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
						<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
						<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
						<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
										
						</select>	 


															
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>	
			<div className="form-left">
				<div className="form-group">
					<label>Font Size  :</label>
					<div>
						<input type="text" name="fontSize" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.fontSize}

						data-id={idx}
						id={FontSize}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Letter Spacing  :</label>
					<div>
						<input type="text" name="letterSpacing" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.letterSpacing}

						data-id={idx}
						id={letterSpacing}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>
			{
			(FontType =='smallbutton' || FontType=='largebutton' || FontType == 'pluginOpenButton') ?
				<>
				<div className="form-left">
					<div className="form-group">
						<label>Top Space :</label>
						<div>
							<input type="text" name="topSpace" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							value={val.topSpace}
							data-id={idx}
							id={TopSpace}    /> 
										
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>
				
				<div className="form-right">
					<div className="form-group">
						<label>Bottom Space :</label>
						<div>
							<input type="text" name="bottomSpace" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							value={val.bottomSpace}
							data-id={idx}
							id={BottomSpace}    /> 									
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>					
				</>
			: ''
			}
			{
			(FontType =='smallbutton' || FontType=='largebutton' || FontType == 'pluginOpenButton') ?
				<>					
				<div className="form-left">
					<div className="form-group">
						<label>Radius :</label>
						<div>
							<input type="text" name="radius" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							value={val.radius}
							data-id={idx}
							id={radius}    /> 	
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>
				</>
			: ''
			}
		</>);
	}

handleFileChange = (e, idx) => {
	let	font_file = `font_file${idx}`;
	let fontDetails = [...this.state.fontDetails];
	fontDetails[e.target.dataset.id]['varient_id'] = idx;	
	fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
	
	this.setState({
			fontDetails: 			  
			  fontDetails
		  });

}; 
// ================================font end ====================


onChangeHandler=(r,event)=>{
	let reader = new FileReader();
	const file = event.target.files[0];
	reader.onloadend = () => {

		if(r == 'loader_image'){
			this.setState({
				loader_image_name: file.name,
				loader_image_preview: reader.result,
				loader_image: file
			});
		} 
		else if(r == 'invite_image'){
			this.setState({
				invite_image_name: file.name,
				invite_image_preview: reader.result,
				invite_image: file
			});
		}
		else if(r == 'mail_image'){
			this.setState({
				mail_image_name: file.name,
				mail_image_preview: reader.result,
				mail_image: file
			});
		}
	
	};
	reader.readAsDataURL(file);
}
	handleChange = (r, selOption) => {
		if (r == "plugin_size") {
		this.setState({ selPluginSize: selOption });
		this.setState({ plugin_size: selOption.value });
		}
	};

	handleSubmit = () => {
		const popup = document.querySelector(".shadow-input-popup-action");
		if (popup) {
		popup.classList.remove("show");
		}
	};

	confirmPopupold = () => {
		$(".shadow-input-popup-action").addClass("show");
	};

	confirmPopup = (type) => {
		this.setState({ activeShadowType: type });
		$(".shadow-input-popup-action").addClass("show");
	};
 	handleShadowChange = (value) => {
		this.setState((prevState) => ({
		shadows: {
			...prevState.shadows,
			[this.state.activeShadowType]: value,
		},
		}));
	};

	handleCancel = () => {
		const popup = document.querySelector(".shadow-input-popup-action");
		if (popup) {
		popup.classList.remove("show");
		}
	};

	labelFor = (key) => {
		const labels = {
		pluginShadow: "Plugin Shadow",
		dashboardShadowGrid: "Dashboard Grid Shadow",
		dashboardShadowList: "Dashboard List Shadow",
		//sideMenu: "Sidemenu Shadow",
		//shortcutMenu: "Shortcut Menu Shadow (Shotcut menu, AI screen textarea)",
		largeButton: "Button Shadow",
		textarea: "Textarea Shadow (Invite friend page textarea)",
		shadowPluginOpenButton: "Open Button Shadow",
		shadowDropdownMenu: "Dropdown Shadow (Bell notification, Group menu in listing screen)",
		shadowSearchDropdown: "Search Dropdown Shadow",
		shadowAISidebar: "AI Sidebar Shadow",
		shadowListRow: "List Shadow",
		shadowTableRow: "Table Shadow",
		//shadowPluginInset: "Plugin Inset Shadow",
		shadowPluginInsetLeft: 'Plugin Inside Left Shadow',
		shadowPluginInsetRight: 'Plugin Inside Right Shadow',
		shadowPluginInsetTop: 'Plugin Inside Top Shadow',
		shadowPluginInsetBottom: 'Plugin Inside Bottom Shadow',

			shadowInput: "Input Box Shadow",
			shadowText: "Text Shadow (Result)",
			shadowLeftSidebar: "Left Sidebar Shadow (Side menu)",
			shadowRightSidebar: "Right Sidebar Shadow (Chat window)",
			shadowMainAITextarea: "AI Screen Textarea Shadow",
			shadowPluginOpenButtonInset: "Open Button Inset Shadow",
		};
		return labels[key] || key;
	};

	handleInputChangeShadows = (type, value) => {
		this.setState((prevState) => ({
		shadows: {
			...prevState.shadows,
			[type]: value,
		},
		}));
	};
	handlePositionChange = (selectedOption) => {
		this.setState({ st_position: selectedOption.value },()=>{
			if(selectedOption.value =='absolute'){
				$('.d-height').removeClass('d-none');
			}else{
				$('.d-height').addClass('d-none');
			}
		});
	};

	handleChangeTheme = sel => {
		this.setState({ selTheme : sel});
		this.setState({ theme_id : sel.value });
	}



  render() {
	 
  	/* const styles = reactCSS({
      'default': {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: `${ this.state.hexColor }`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    }); */
	//let test1 = this.state.settings_access_code;
	let test1 = 752807;
	//let test = Number(this.state.settings_access_code);
	
	const scripttype = '';
	
		/*const tester =	'<!-- Include <div> tag after the script -->\n<script src="http://car-c.uxt.design/plugin.js"></script>\n<div data-client="'+test+'"  id="car_container"></div>';
		*/
		
		
	//let  tester =	'<script src="http://connect.uxt.design/assets/js/plugin.js"></script> <div data-client="'+test1+'"  id="uxt_container"></div>';
	let  tester =	'<script src="http://dev.uxt.design/assets/js/plugin.js"></script> <div data-client="'+test1+'"  id="uxt_container"></div>';


	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	id: index,
	name: fonttype,
	}));
	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
	fonts.push({ label: item.name.label, value: item.name.value }),
	);

	const {selectedFont,selectedfaqmodeluser,selectedfaqmodelguest,selectedfaqmodelrehab,selectedfaqmodelcompany,selPluginSize,selectedallmodel, selPluginSizeVal, pluginSizeDetails, productSortDetails, selProductSort, selTheme} = this.state;

	const style_text = {
	color: 'white',
    backgroundColor: '#000',
    padding: '9px 9px',
    minwidth: '49px',
    height: '37px',
	textalign:'center',
    texttransform: 'capitalize'
}

	if(this.state.cancellation_fees_type == 'flat')
	{
		$('.cancellation_fee').html('Cancellation fees ($):')
		
	}else{
		$('.cancellation_fee').html('Cancellation fees (%):')
	}	
	if(this.state.reschedule_fees_type == 'flat')
	{
		$('.reschedule_fee').html('Reschedule fees ($):')
		
	}else{
		$('.reschedule_fee').html('Reschedule fees (%):')
	}	
	var refresh_token = this.state.dr_refresh_token;
	var yourclientid = this.state.drchrono_client_id;
	if(this.state.drchrono_client_id =='' && this.state.drchrono_client_secret_key =='' ){

		refresh_token = "";

	}

	if(this.state.drchrono_client_id =='' ){


		yourclientid = "YOUR_CLIENT_ID";
	}
	//console.log(this.state.domain_count,"domain_countdomain_count")
    return (
      <div className="wrapper"> 
 
	  <Header />
	  <MenuSidebar currentpage="setting" />		

	
	<div className="content">	
		<div className="content-wrapper">
		  <div class="content-wrapper-before"></div>
			<div className="content-body setting-main-head leaa-admin-head card">
			<form className="settings" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}  encType="multipart/form-data">
			<div className="form-wrapper">
			<div className="success_message"></div>
			<div className="title">
				<h4>Settings</h4>
			</div>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
				{localStorage.getItem('admin_id') == 1 ?<label>Site Name<span class="required" style={{ color: "red" }} >* </span></label>:<label>Company Name<span class="required" style={{ color: "red" }} >* </span></label>}
					
					<input type="text" name="settings_site_title" onChange={this.handleInputChange} className="form-control" value={this.state.settings_site_title} />
					{/* <CKEditor
							editor={ ClassicEditor }
							data={this.state.settings_site_title}
							onReady={ editor => {
								// You can store the "editor" and use when it is needed.
								console.log( 'Editor is ready to use!', editor );
							} }
							name="settings_site_title"
							// onChange={this.handleInputChange}
							onChange={ ( event, editor ) => {
								const data = editor.getData();
								this.setState({settings_site_title: data});
								
							} }
						/> */}
					<div className="errorsettings_site_title"></div>
				</div>
				<div className="form-group">					
					<label>From Name<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" name="settings_from_name" onChange={this.handleInputChange} className="form-control"value={this.state.settings_from_name} />
					<div className="errorsettings_from_name"></div>
				</div>
				<div className="form-group">
					<label>From Email<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" name="settings_from_email"  onChange={this.handleInputChange} className="form-control" value={this.state.settings_from_email} />
					<div className="errorsettings_from_email"></div>
				</div>
				<div className="form-group">					
					<label>Upload Mail Logo</label>
					<input type="file" name="st_email_logo" onChange={this.onChangeHandler.bind(this, 'mail_image')} />
					{this.state.mail_image_preview && (
						<div className="image-preview">
							<img src={this.state.mail_image_preview} alt="Preview" className='img_class' />
						</div>		
					)}	
				</div>	
				{this.state.st_email_logo ? 
				<div className="form-group">
					<a className="thumbnail" href="javascript:;" title="">
						<img className="img-responsive common_delete_image" width="100" src={mediaUrl+'admin/email/'+this.state.st_email_logo} />
					</a>
				</div>
				: ''}	
		

			
			</div>
			<div className="form-right">

				<div className="form-group">					
				{localStorage.getItem('admin_id') == 1 ? <label>Admin Email<span class="required" style={{ color: "red" }} >* </span></label>:<label>Company Email:</label>} 
					<input type="text" className="form-control" onChange={this.handleInputChange} name="settings_admin_email" value={this.state.settings_admin_email} />
					<div className="errorsettings_admin_email"></div>
				</div>
				
				<div className="form-group">
					<label>Contact<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" className="form-control" name="settings_mobileno"  onChange={this.handleInputChange} value={this.state.settings_mobileno}/>
					<div className="errorsettings_mobileno"></div>
				</div>

				<div className="form-group"> 
					<label>Email Footer Content<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" className="form-control" name="settings_email_footer" onChange={this.handleInputChange} value={this.state.settings_email_footer}/>
					<div className="errorsettings_email_footer"></div>
				</div>
				
						
				{/* <div className="form-group">
					<label>Payment Form:</label><br></br>
					    <input onChange={this.handleInputChange} type="radio" name="payment_form" checked={this.state.payment_form=='normal'?'chekced':''} value="normal"/>
	                <span>Normal</span>
	                 <input onChange={this.handleInputChange} type="radio"  name="payment_form" checked={this.state.payment_form=='widget'?'chekced':''} value="widget"/>
	                <span>Widget</span>
            	</div>  */}


				{/* { localStorage.getItem('admin_id') == 1 ? <div className="form-group site-bg-clr"> 
				<label>Site Background Color: </label>
						<div style={ styles.swatch } onClick={ this.handleClick }>
						<div style={ styles.color } />
						</div>
						{ this.state.displayColorPicker ? <div style={ styles.popover }>
						<div style={ styles.cover } onClick={ this.handleClose }/>
						<SketchPicker color={ this.state.color } onChange={ this.handleChange } />
						</div> : null }
				</div> : '' } */}

				  
			</div>				
			</div>	
		    <div className="title">
				<h4>Mail Configuration Settings</h4>
			</div> 
			
			 <div className="form-group">
				    <input onChange={this.handleInputChange} type="checkbox"  name="settings_mail_from_smtp" checked={this.state.smtp_checked}/>
	                <span>Send Mail From Smtp</span>
            </div> 

		 <div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Smtp Host:</label>
					<input type="text" className="form-control" name="settings_smtp_host" onChange={this.handleInputChange}  value={(this.state.settings_smtp_host != 'null')?this.state.settings_smtp_host:''}/>
					<div className="errorsettings_smtp_host"></div>
				</div>
				<div className="form-group">					
					<label>Smtp Username:</label>
					<input type="text" className="form-control" name="settings_smtp_user"  onChange={this.handleInputChange}  value={(this.state.settings_smtp_user != 'null')?this.state.settings_smtp_user:''} />
					<div className="errorsettings_smtp_user"></div>
				</div>					
				<div className="form-group">
					<label>Smtp Password:</label>
					<input type="password" className="form-control" name="settings_smtp_pass" onChange={this.handleInputChange}  value={(this.state.settings_smtp_pass != 'null')?this.state.settings_smtp_pass:''} />
				<div className="errorsettings_smtp_pass"></div>
				</div>
			</div>			
			<div className="form-right">
				<div className="form-group">					
					<label>Smtp Port:</label>
					<input type="text" className="form-control"  name="settings_smtp_port" onChange={this.handleInputChange}  value={(this.state.settings_smtp_port != 'null')?this.state.settings_smtp_port:''} />
				<div className="errorsettings_smtp_port"></div>
				</div>
				<div className="form-group"> 
					<label>Mail Path:</label>
					<input type="text" className="form-control" name="settings_mailpath" onChange={this.handleInputChange} placeholder=""  value={(this.state.settings_mailpath != 'null')?this.state.settings_mailpath:''}/>
				</div>
			</div>	
			</div> 
				

				

		<div className="title">
				<h4> Embed Code</h4>
			</div> 
		<div className="form-row">

		{ /*<div className={`shadow-input-popup-action ${this.state.shortcutBoxShadowSt ? 'show' : ''}`}>
			<span className='shadow-input-close' onClick={this.boxShadowFunc.bind(this)}>X</span>
			<div className='title'>
				<h4>Shortcut box shadow</h4>
			</div>

			<div className='shadow-picker-container d-flex w-100 justify-content-between'>
				<ShadowPicker
				value={this.state.shadow}
				onChange={(value) => {
					this.setState({shadow : value});
				}}
				className='shadow-picker'
				/>
				
				<div className='shadow-box' style={{boxShadow: this.state.shadow}}>
				</div>
      		</div>

			<div className='d-flex w-100 justify-content-end gap-2 mt-5'>
			    <button type="button" className='shadow-btn' onClick={this.saveboxShadowFunc.bind(this)}>Save</button>
			</div>
		</div> */ }

				<div className="form-left">
					<div className="form-group">
						<label>Embed Code<span class="required" style={{ color: "red" }} >* </span></label>
						<p className="right-side-header"  id="embed_code" name="settings_embedcode" value={tester} title="Copy Text" >{tester}</p>
						<br></br>
						<a id='copytext' style={style_text} onClick={this.writeText}   >Copy  </a> <br></br>
						<div><br></br><div className="copied_title"></div></div>
						<div className="errorsettings_embedcode_title"></div>
					</div>
					
					<div className='form-group'>
						<h4>Google Analytics code </h4>
						<textarea type="text" name="google_analystic_code" onChange={this.handleInputChange} className="form-control" value={this.state.google_analystic_code} />
					</div>
				</div>	
				<div className="form-right">
				    <div className='form-group'>
					<h4>Domain<span class="required" style={{ color: "red" }} >* </span></h4>
				    <div className="domain-url">
					<Addinputsimple myCallback={this.myCallback} domainname={this.state.domainSets} domain_count = {this.state.domain_count}/>
					</div>
					<div className="errorsettings_domain"></div>
					</div>
				</div>				
			</div>
			 {/* <h5>Plugin Position (Numbers Only)</h5>  */}
			<div className="title">
				<h4>Plugin Management</h4>
		   	</div> 

			<h4 class="fs-5">Plugin Positions</h4>

			<div className="form-row mb-0">			
				{/* <div className="form-left">
					<div className="form-group">
						<label>Position : </label>
						<input onChange={this.handleInputChange} type="checkbox"  name="st_position" checked={this.state.st_position_checked}/>
	                    <span>Fixed</span>
					</div>
				</div> */}
				<div className="form-left">
					<div className="form-group">
						<label>Position</label><br/>
						<Select
						name="st_position"
						value={lang.common.pluginPosition.find(
							option => option.value === this.state.st_position
						)}
						options={lang.common.pluginPosition}
						onChange={this.handlePositionChange}
						/>
					</div>
				</div>
				<div className="form-right">
					<div className="form-group d-height d-none">
						<label>Plugin Height</label>
						<input type="text" className="form-control" name="st_plugin_height"  onChange={this.handleInputChange} value={this.state.st_plugin_height}/>
						<div className="errorst_st_plugin_height"></div>
					</div>
				</div>
			</div>

			<div className="form-row">			
				<div className="form-left">
					<div className="form-group">
						<label>Position Left (%) : </label>
						<input type="number" className="form-control" name="st_position_left"  onChange={this.handleInputChange} value={this.state.st_position_left}/>
						<div className="errorsettings_st_position_left"></div>
					</div>
					<div className="form-group">
						<label>Position Right (%) :</label>
						<input type="number" className="form-control" name="st_position_right"  onChange={this.handleInputChange} value={this.state.st_position_right}/>
						<div className="errorsettings_st_position_right"></div>
					</div>
				</div>

				<div className="form-right">
					<div className="form-group">
						<label>Position Top (%) :</label>
						<input type="number" className="form-control" name="st_position_top"  onChange={this.handleInputChange} value={this.state.st_position_top}/>
						<div className="errorsettings_st_position_top"></div>
					</div>
					<div className="form-group">
						<label>Position Bottom (%) : </label>
						<input type="number" className="form-control" name="st_position_bottom"  onChange={this.handleInputChange} value={this.state.st_position_bottom}/>
						<div className="errorsettings_st_position_bottom"></div>
					</div>	
				</div>
			</div>

			<h4 class="fs-5">Plugin Inner Space</h4>

			<div className="form-row">			
				<div className="form-left">
					<div className="form-group">
						<label>Left Space (px) :</label>
						<input type="number" className="form-control" name="st_plugin_left_space"  onChange={this.handleInputChange} value={this.state.st_plugin_left_space}/>
						<div className="errorsettings_st_plugin_left_space"></div>
					</div>
					<div className="form-group">
						<label>Right Space (px) :</label>
						<input type="number" className="form-control" name="st_plugin_right_space"  onChange={this.handleInputChange} value={this.state.st_plugin_right_space}/>
						<div className="errorsettings_st_plugin_right_space"></div>
					</div>
				</div>

				<div className="form-right">
				<div className="form-group">
						<label>Top Space (px) : </label>
						<input type="number" className="form-control" name="st_plugin_top_space"  onChange={this.handleInputChange} value={this.state.st_plugin_top_space}/>
						<div className="errorsettings_st_plugin_top_space"></div>
					</div>
					<div className="form-group">
						<label>Bottom Space (px) :</label>
						<input type="number" className="form-control" name="st_plugin_bottom_space"  onChange={this.handleInputChange} value={this.state.st_plugin_bottom_space}/>
						<div className="errorsettings_st_plugin_bottom_space"></div>
					</div>
				</div>
			</div>




			 <div className="form-row">			
				<div className="form-left">
					
					{/* <div className="form-group">
						<label>Show category icons: </label>
					    <input onChange={this.handleInputChange} type="radio" name="category_icons" checked={this.state.category_icons_yes}/>
		                <span>Yes</span>
		                 <input onChange={this.handleInputChange} type="radio"  name="category_icons" checked={this.state.category_icons_no}/>
		                <span>No</span>
 					</div>  */}
					 {/* <div className="form-group">
						<label>Dashboard View: </label>
					    <input onChange={this.handleInputChange} type="radio" name="dashboard_view" value="list" checked={(this.state.dashboard_view == "list" ? "checked" : "" )}/>
		                <span>List</span>
		                 <input onChange={this.handleInputChange} type="radio"  name="dashboard_view" value="grid" checked={(this.state.dashboard_view == "grid" ? "checked" : "" )}/>
		                <span>Grid</span>
 					</div>  */}
					
					<div className="form-group">
						<label>Product Sort By </label>
						<Select 
							options={productSortDetails}  
							value={selProductSort?selProductSort:{ value: 'asc', label: 'Price Asc' }}
							onChange={this.handleChange.bind(this, 'product_sort_by')}
							placeholder="Select product sort" 
						/>
						<div className="errorpluginsize"></div>
					</div>
					 
					<div className="form-group">
						<label for="st_loader_text" className="form-label">Loader Text</label>
						<input type="text" className="form-control" name="st_loader_text"  onChange={this.handleInputChange} value={this.state.st_loader_text}/>
						<div className="errorsettings_st_loader_text"></div>
					</div>

					<div className="form-group">
						<label></label>						
						<div className='d-flex'>
						<input onChange={this.handleInputChange} type="checkbox"  name="plugin_outer_space" checked={this.state.pluginOuterSpaceChecked}/>
						<p>Plugin outer space in mobile</p>
						</div>
 					</div> 

					<div className="form-group">
						<label>Display Tab: </label>
						<div className='d-flex flex-wrap'>
					    <div className="m-2">
						<input onChange={this.handleInputChange} type="radio" name="display_tab" value="adsTab" checked={(this.state.display_tab == "adsTab" ? "checked" : "" )}/>
		                Advertisement
						</div>
						<div className="m-2">
		                 <input onChange={this.handleInputChange} type="radio"  name="display_tab" value="noTab" checked={(this.state.display_tab == "noTab" ? "checked" : "" )}/>
		                Search Input
						</div>
						<div className="m-2">
						<input onChange={this.handleInputChange} type="radio"  name="display_tab" value="aiTab" checked={(this.state.display_tab == "aiTab" ? "checked" : "" )}/>
		                AI Widget
						</div>
						</div>
 					</div> 
				</div>
				<div className="form-right">
					
						
					{/* <div className="form-group">
						<label>Notification Popup Theme: </label>
						<br/>
					    <input onChange={this.handleInputChange} type="radio" name="np_theme" value="Black" checked={(this.state.np_theme == "Black" ? "checked" : "" )}/>
		                <span>Black bg with White text</span>
						<br/>
		                 <input onChange={this.handleInputChange} type="radio"  name="np_theme" value="White" checked={(this.state.np_theme == "White" ? "checked" : "" )}/>
		                <span>White bg with Black text</span>
 					</div> */}
					 {/* <div className="form-group">
						<label>Plugin Size: </label>
					    <input onChange={this.handleInputChange} type="radio" name="plugin_size" value="600" checked={(this.state.plugin_size == "600" ? "checked" : "" )}/>
		                <span>600px</span>
		                 <input onChange={this.handleInputChange} type="radio"  name="plugin_size" value="700" checked={(this.state.plugin_size == "700" ? "checked" : "" )}/>
		                <span>700px</span>
 					</div>  */}
					
					 <div className="form-group">
						<label>Plugin Size </label>
						<Select 
							options={pluginSizeDetails}  
							value={selPluginSize?selPluginSize:{ value: 'small', label: '600 px' }}
							onChange={this.handleChange.bind(this, 'plugin_size')}
							placeholder="Select plugin size" 
						/>
						<div className="errorpluginsize"></div>
					</div>
					
					
					<div className="form-group">
						<label>AI Width (%) :</label>
						<input type="number" className="form-control" name="st_plugin_ai_width"  onChange={this.handleInputChange} value={this.state.st_plugin_ai_width}/>
						<div className="errorsettings_st_plugin_ai_width"></div>
					</div>
					{/* <div className="form-group">
						<label>Product Layout: </label>
					    <input onChange={this.handleInputChange} type="radio" name="product_layout" checked={this.state.product_layout2_checked}/>
		                <span>2 Layout</span>
		                 <input onChange={this.handleInputChange} type="radio"  name="product_layout" checked={this.state.product_layout3_checked}/>
		                <span>3 Layout</span>
 					</div> 

					 <div className="form-group">
						<label>Header category limit: </label>
						<input type="number" className="form-control" name="header_cat_limit"  onChange={this.handleInputChange} value={this.state.header_cat_limit}/>
						
					</div> */}
					


					 <div class="form-group">
						<label for="st_loader_image" class="form-label">Loader Image</label>
						<input type="file" name="st_loader_image" onChange={this.onChangeHandler.bind(this, 'loader_image')} />
						{this.state.loader_image_preview && (
						<div className="image-preview">
						<img src={this.state.loader_image_preview} alt="Preview" className='img_class' />
						</div>		
						)}				
					</div>
					
					{this.state.st_loader_image ? 
					
					<div className="form-group">
						
						<a className="thumbnail" href="javascript:;" title="">
							<img className="img-responsive common_delete_image" width="100" src={mediaUrl+'loader/'+this.state.st_loader_image} />
						</a>
					</div>
					: ''}	
				</div>
			</div> 
			

		   <div className="title">
				<h4>Invite friends settings</h4>
		   </div> 
		   	<div className="form-row">
				<div className="form-left">
					<div className="form-group">
						<label>Welcome Invite Friends Content</label>
						<textarea className="announcementTextArea form-control" name="welcome_invite_friends" cols="80" rows="5" value={this.state.welcome_invite_friends} onChange={this.handleInputChange}></textarea>
						<div className="error_welcome_invite_friends"></div>
					</div>					
				</div>	
				<div className="form-right">
					<div className="form-group">					
						<label>Upload Invite Image</label>
						<input type="file" name="st_invite_image" onChange={this.onChangeHandler.bind(this, 'invite_image')} />
						{this.state.invite_image_preview && (
						<div className="image-preview">
						<img src={this.state.invite_image_preview} alt="Preview" className='img_class' />
						</div>		
						)}	
					</div>	
					{this.state.st_invite_image ? 
					<div className="form-group">
						<a className="thumbnail" href="javascript:;" title="">
							<img className="img-responsive common_delete_image" width="100" src={mediaUrl+'loader/'+this.state.st_invite_image} />
						</a>
					</div>
					: ''}	
				</div>	
			</div>	

		   <div className="title">
				<h4>Stripe Configuration</h4>
		   </div> 
		   <div className="form-group">
				    <input onChange={this.handleInputChange} type="radio" name="settings_enable_live" checked={this.state.stripe_live_checked}/>
	                <span>Live</span>
	                 <input onChange={this.handleInputChange} type="radio"  name="settings_enable_sandbox" checked={this.state.stripe_sandbox_checked}/>
	                <span>SandBox</span>
            </div> 
			<div className="form-row">
			<div className="form-left">
			<div className="form-group">
					<label>Public Key<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" className="form-control" name="settings_public_key" onChange={this.handleInputChange}  value={this.state.settings_public_key}/>
					<div className="errorsettings_public_key"></div>
				</div>

				<div className="form-group">
					<label>Product Key</label>
					<input type="text" className="form-control" name="settings_product_key" onChange={this.handleInputChange}  value={this.state.settings_product_key}/>
					<div className="errorsettings_product_key"></div>
					<span>Note : For Recurring payment(Monthly) the product key use.</span>
				</div>
					
			</div>	
			<div className="form-right">
				
			<div className="form-group">					
					<label>Secret Key<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="password" className="form-control" name="settings_secret_key"  onChange={this.handleInputChange}  value={this.state.settings_secret_key} />
					<div className="errorsettings_secret_key"></div>
				</div>		
			</div>	
      	</div>	

		  	<div className="title">
				<h4>Plugin Content</h4>
		   	</div> 		   
			<div className="form-row">
				<div className="form-left">
					<div className="form-group">
						<label>Chat AI key</label>
						<input type="text" className="form-control" name="chat_ai_key" onChange={this.handleInputChange}  value={this.state.chat_ai_key}/>
						<div className="errorchat_ai_key"></div>
					</div>
					
					<div className="form-group">					
						<label>Plugin Close Content</label>
						<input type="text" className="form-control" name="plugin_close_content"  onChange={this.handleInputChange}  value={this.state.plugin_close_content} />
						<div className="errorplugin_close_content"></div>
					</div>	
					<div className="form-group">					
						<label>Google Conversion Code</label>
						<input type="text" className="form-control" name="google_conversation_code"  onChange={this.handleInputChange}  value={this.state.google_conversation_code} />
						<div className="errorgoogle_conversation_code"></div>
					</div>	
					<div className="form-group">					
						<label>Earnings Claim Content</label>
						<input type="text" className="form-control" name="st_earning_claims_content"  onChange={this.handleInputChange}  value={this.state.st_earning_claims_content} />
						<div className="errorst_earning_claims_content"></div>
					</div>	
					<div className="form-group">					
						<label>Invite Earning Amount ($)</label>
						<input type="text" className="form-control" name="st_invite_earning_amount"  onChange={this.handleInputChange}  value={this.state.st_invite_earning_amount} />
						<div className="errorst_invite_earning_amount"></div>
					</div>	
					<div className="form-group">					
						<label>Line Color</label>
						<input type="color" className="form-control" name="st_line_color"  onChange={this.handleInputChange}  value={this.state.st_line_color} />
						<div className="errorst_line_color"></div>
					</div>	
					<div className="form-group">
						<label>Product Image: </label>
					    <input onChange={this.handleInputChange} type="radio" name="st_product_image" value="with_img" checked={(this.state.st_product_image == "with_img" ? "checked" : "" )}/>
		                With Image
		                 <input onChange={this.handleInputChange} type="radio"  name="st_product_image" value="without_img" checked={(this.state.st_product_image == "without_img" ? "checked" : "" )}/>
		                Without Image
 					</div> 
					 
					
				</div>	
				<div className="form-right">
					{/* <div className="form-group">					
						<label>Domain Data Feed</label>
						<Select 
							options={this.state.faqmodelguest}  
							value={selectedfaqmodelguest?selectedfaqmodelguest:{ value: '0', label: 'Select guest ai model' }}
							onChange={this.handleChangeAimodelguest}
							placeholder="Select AI Model ID" 
						/>			
					</div> */}
					<div className="form-group">
						<label>ChatGPT Model ID</label>
						<Select 
							options={this.state.all_models}  
							value={selectedallmodel?selectedallmodel:{ value: '0', label: 'Select ai model' }}
							onChange={this.handleChangeAllmodelguest}
							placeholder="Select AI Model ID" 
						/>	
						<div className="errorchat_ai_key"></div>
					</div>
					<div className="form-group">
						<label>Tracking Limit (For Free User Only)</label>
						<input type="text" className="form-control" name="tracking_limit" onChange={this.handleInputChange}  value={this.state.tracking_limit}/>
						<div className="errortracking_limit"></div>						
					</div>
					<div className="form-group">
						<label>Upgrade to PRO (For Free User Only)</label>
						<input type="text" className="form-control" name="upgrade_content" onChange={this.handleInputChange}  value={this.state.upgrade_content}/>
						<div className="errorupgrade_content"></div>						
					</div>
					<div className="form-group">
						<label>Invite Friends Content</label>
						<input type="text" className="form-control" name="invite_friends" onChange={this.handleInputChange}  value={this.state.invite_friends}/>
						<div className="errorinvite_friends"></div>						
					</div>
					<div className="form-group">
						<label>Invite claim eligible</label>
						<input type="text" className="form-control" name="st_invite_claim_eligible" onChange={this.handleInputChange}  value={this.state.st_invite_claim_eligible}/>
						<div className="errorst_invite_claim_eligible"></div>						
					</div>
					<div className="form-group">
						<label>Image size in Percentage (%)</label>
						<input type="number" name="st_product_image_size" value={this.state.st_product_image_size} className="form-control"  onChange={this.handleInputChange} /> 
						<div className="errorst_product_image_size"></div>						
					</div>
					<div className="form-group">
						<label>Product Line: </label>
					    <input onChange={this.handleInputChange} type="radio" name="st_product_line" value="with_line" checked={(this.state.st_product_line == "with_line" ? "checked" : "" )}/>
		                With Line
		                 <input onChange={this.handleInputChange} type="radio"  name="st_product_line" value="without_line" checked={(this.state.st_product_line == "without_line" ? "checked" : "" )}/>
		                Without Line
 					</div>
					 	

					{/* <div className="form-group admin-panel-btn">
						<label>Shortcut box shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="shortcutBoxShadowDet" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this)} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div>  */}
				</div>	
      		</div>	

			{/* <div className="title">
				<h4>Feed domain data</h4>
			</div>
			<div className="form-group">					
				<label>Type</label>
				<input type="radio" name='type' value="text" onChange={this.handleInputChange}/> AI Texting
				<input type="radio" name='type' value="chat" onChange={this.handleInputChange}/> Assitant Chat 
			</div>  		
			<div className="form-group">					
				<CKEditor
					editor={ ClassicEditor }
					data={this.state.description}
					onReady={ editor => {
						// You can store the "editor" and use when it is needed.
						//console.log( 'Editor is ready to use!', editor );
					} }
					name="aifeed_desc"
					// onChange={this.handleInputChange}
					onChange={ ( event, editor ) => {
						const data = editor.getData();
						this.setState({description: data});
						
					} }
				/>
				<div className="errordescription"></div>		
			</div>
			<button className='ai-feedbtn mt-3' onClick={this.handleSave}>AI Feed</button> */}


			{/* <div className="title">
				<h4>Ai Sidebar Management</h4>
		   	</div> 		   
			<div className="form-row">
				<div className="form-left">
					<div className="form-group">
						<label>Sidebar Expended size (px):</label>
						<input type="text" className="form-control" name="st_aisidebar_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_width}/>
						<div className="errorsst_aisidebar_width"></div>
					</div>						
							
					<div className="form-group">
						<label>Sidebar Icon Size (px):</label>
						<input type="text" className="form-control" name="st_aisidebar_icon_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_icon_width}/>
						<div className="errorsst_aisidebar_icon_width"></div>
					</div>			
				</div>	
				<div className="form-right">
					<div className="form-group">
						<label>Sidebar Collapsed size (px):</label>
						<input type="text" className="form-control" name="st_aisidebar_collapsed_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_collapsed_width}/>
						<div className="errorsst_aisidebar_collapsed_width"></div>
					</div>	
														
				</div>	
				
			</div> */}


			{/* 			
			<div className="title">
                <h4>Shadow Management</h4>
			</div>

			<div className="form-row">
				<div className="shadow-input-popup-action">
					<span
					className="shadow-input-close"
					onClick={this.handleCancel}
					>
					X
					</span>
					<div className="title">
						<h4 style={{ fontSize: "30px" }}>
							{this.labelFor(this.state.activeShadowType)}
						</h4>
					</div>
					<div className="shadow-picker-container d-flex w-100 justify-content-between">
						<ShadowPicker
							value={
							this.state.shadows[this.state.activeShadowType] ||
							""
							}
							onChange={(value) => this.handleShadowChange(value)}
							className="shadow-picker"
						/>

						<div
							className="shadow-box"
							style={{
							boxShadow:
								this.state.shadows[this.state.activeShadowType] ||
								"none",
							}}
						></div>
					</div>
					<div className="d-flex w-100 justify-content-end gap-2 mt-5">
						<button type="button" className="shadow-btn" onClick={this.handleSubmit}>
							Save
						</button>
					</div>
				</div>
			</div>

			<div className="form-row">
				{Object.entries(this.state.shadows).map(([key, value]) => (
					<div className="form-left" key={key}>
						<div className="form-group admin-panel-btn">
							<label>{this.labelFor(key)}:</label>
							<input
							value={value}
							type="text"
							autoComplete="off"
							className="form-control"
							style={{ width: "85%" }}
							onChange={(e) =>
								this.handleInputChangeShadows(key, e.target.value)
							}
							/>
							<button
							type="button"
							onClick={() => this.confirmPopup(key)}
							style={{
								color: "white",
								padding: "14px",
								minWidth: "47px",
								height: "48px",
								backgroundColor: "rgb(5, 31, 58)",
								borderRadius: "0px 5px 5px 0px",
							}}
							>
							<i>
								<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="#fff"
								viewBox="32 -0.03 543.87 512.03"
								>
								<path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path>
								</svg>
							</i>
							</button>
						</div>
					</div>
				))}
			</div>

			<div className="title">
				<h4>Radius Management</h4>
			</div> 
			<div className="form-row">		
				<div className="form-left">					
					<div className="form-group">					
						<label>Plugin Radius (px):</label>
						<input type="text" className="form-control" name="pluginRadius"  onChange={this.handleInputChange}  value={this.state.pluginRadius} />
						<div className="errorpluginRadius"></div>
					</div>
					<div className="form-group">
						<label>Input Box Radius (px):</label>
						<input type="text" className="form-control" name="inputRadius"  onChange={this.handleInputChange} value={this.state.inputRadius}/>
						<div className="errorinputRadius"></div>
					</div>	
				</div>
				<div className="form-right">					
					<div className="form-group">
						<label>Dropdown Radius (px) (Bell notification, Grouping menu listing) </label>
						<input type="text" className="form-control" name="dropdownRadius"  onChange={this.handleInputChange}  value={this.state.dropdownRadius} />
						<div className="errordropdownRadius"></div>
					</div>
					<div className="form-group">
						<label>Textarea Radius (px) (AI screen textarea, Invite friend textarea):</label>
						<input type="text" className="form-control" name="textareaRadius"  onChange={this.handleInputChange} value={this.state.textareaRadius}/>
						<div className="errortextareaRadius"></div>
					</div>
				</div>
			</div>

		  	<div className="title">
				<h4>Font Management</h4>
			</div> 
			<div className="form-row">		
				<div className="form-left">					
					<div className="form-group">
						<label>Line Height</label>
						<input type="text" className="form-control" name="line_height" onChange={this.handleInputChange}  value={this.state.line_height}/>
						<div className="errorlineHeight"></div>
					</div>
				</div>
			</div>			
			{this.addMoreFunc()}
			
			*/}

			
			<div className="title">
				<h4>Theme Management</h4>
			</div> 
			
			<div className="form-row">		
				<div className="form-left">
					<div className="default-font">
						<div className="form-group">
							<label>Theme :</label>
							<Select 
								options={this.state.themeData}  
								value={selTheme?selTheme:{ value: '0', label: 'Select Theme' }}
								onChange={this.handleChangeTheme}
								placeholder="Select theme"
							/>
							<div className="errortheme"></div>
						</div>
					</div> 
				</div> 
			</div>		 

		 
			 <div className="btn-group export">	
				
                <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
                                <span className="load-data">Loading</span> 
                                } Submit
			    </button>	
			</div>

			</div>
			</form>
			</div>	
		</div>	
	</div>
		 	
    </div>
    );
  }
}

export default Setting;